import { jsx as e, jsxs as d, Fragment as be } from "react/jsx-runtime";
import * as z from "react";
import { useMemo as Z, Suspense as yr, useState as I, useRef as Ie, useEffect as ie, useCallback as ke, useId as br, createContext as Sr, useContext as vr } from "react";
import { Breadcrumb as wr, Card as He, Layout as de, theme as J, Grid as Lt, Spin as En, ConfigProvider as Pn, Tooltip as Mn, Typography as $, Space as Y, Tag as Se, Button as U, Menu as Un, Avatar as Rn, Badge as kr, DatePicker as Bn, Empty as Cr, Drawer as xr, App as Te, Steps as It, Form as _, Select as Je, InputNumber as Dt, Modal as et, Input as V, Popconfirm as _r, Alert as $e, Tree as Tr, Table as ee, Descriptions as ue, Divider as Ar, Row as vt, Col as ct, Progress as Nr, Radio as Xe, Checkbox as Oe, Upload as Lr, Collapse as Ir } from "antd";
import { Link as dt, Outlet as Dr, useNavigate as ht, useLocation as Er } from "react-router-dom";
import { ChevronDownIcon as Pr, BellIcon as Mr } from "@heroicons/react/24/outline";
import { MenuUnfoldOutlined as Ur, MenuFoldOutlined as Rr, DeleteOutlined as Fn, SearchOutlined as Br, DownloadOutlined as Fr, PrinterOutlined as $r, InboxOutlined as Or, SunOutlined as zr, MoonOutlined as Hr, CheckCircleFilled as Wr, FacebookFilled as Vr, WindowsOutlined as jr } from "@ant-design/icons";
import { createAdminSidebarMenuTokens as qr, useTheme as Et, useLocale as Gr } from "@digiwedge/ui-theme";
import { AppThemeProvider as Vl, dark as jl, light as ql, useTheme as Gl } from "@digiwedge/ui-theme";
import te from "dayjs";
import Yr from "dayjs/plugin/advancedFormat.js";
import Kr from "dayjs/plugin/customParseFormat.js";
import Qr from "dayjs/plugin/isoWeek.js";
import Xr from "dayjs/plugin/localeData.js";
import Zr from "dayjs/plugin/weekday.js";
import Jr from "dayjs/plugin/weekOfYear.js";
import eo from "dayjs/plugin/weekYear.js";
import { ResponsiveContainer as to, BarChart as no, XAxis as ro, YAxis as oo, Tooltip as io, ReferenceLine as an, Bar as ao } from "recharts";
import { getMessage as m } from "@digiwedge/i18n-messages";
import { z as so } from "zod";
import { useMutation as lo, QueryClient as co, QueryClientProvider as uo } from "@tanstack/react-query";
import { TenantsApi as mo } from "@digiwedge/access-control-api-client";
import { decodeExp as ho, resolveAudience as go, useLogin as $n, useVerifyLoginMfa as fo, getAuthBroadcastSourceId as po, broadcastAuthEvent as yo, consumeSocialAuthCallbackMarker as bo, resolveSocialAuthCallbackMarker as So, resetRefreshBlock as vo, setSocialAuthCallbackMarker as sn, appendSocialAuthCallbackMarker as ln, classifyAxiosError as cn, useRegister as On, useLogout as wo, useRegisterSmsMfa as ko, useVerifySmsMfa as Co } from "@digiwedge/hooks-auth-web";
import { isVerifiedSocialAuthCallbackReturn as Kl } from "@digiwedge/hooks-auth-web";
import { getTokenDeliveryMode as dn } from "@digiwedge/idp-client";
import { useGlobalStore as St } from "@digiwedge/global-state";
import { getRememberedDeviceDurationDays as xo } from "@digiwedge/types-auth";
import { isAxiosError as un } from "axios";
import { parseLocationForOAuthError as _o } from "@digiwedge/oauth-redirect-utils";
const Xs = ({
  breadcrumbItems: t = [],
  separator: n = ">",
  style: r = { margin: "16px 0" },
  renderItem: o
}) => {
  const i = Z(() => t.map((a, l) => {
    const s = l === t.length - 1;
    let c;
    return o ? c = o(a, s) : s ? c = /* @__PURE__ */ e("span", { style: { fontWeight: "bold" }, children: a.name }) : c = a.path ? /* @__PURE__ */ e(dt, { to: a.path, children: a.name }) : a.name, { title: c };
  }), [t, o]);
  return /* @__PURE__ */ e(wr, { items: i, separator: n, style: r });
}, Zs = ({ img: t, icon: n, title: r }) => /* @__PURE__ */ d(
  He,
  {
    hoverable: !0,
    style: { width: "100%", borderRadius: 12 },
    bodyStyle: {
      padding: 12,
      display: "flex",
      alignItems: "center",
      gap: 4,
      whiteSpace: "nowrap"
    },
    cover: /* @__PURE__ */ e(
      "div",
      {
        style: {
          height: 120,
          backgroundImage: `url(${t})`,
          backgroundSize: "cover",
          backgroundPosition: "center"
        }
      }
    ),
    children: [
      n,
      /* @__PURE__ */ e(
        "div",
        {
          style: {
            fontWeight: 600,
            fontSize: 14,
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap"
          },
          children: r
        }
      )
    ]
  }
), { Content: To } = de, Js = ({
  children: t,
  padding: n,
  responsivePadding: r
}) => {
  const {
    token: { colorBgContainer: o }
  } = J.useToken(), i = Lt.useBreakpoint(), a = z.useMemo(() => {
    if (r) {
      const l = ["xxl", "xl", "lg", "md", "sm", "xs"];
      for (const s of l)
        if (i[s] && typeof r[s] == "number")
          return r[s];
    }
    return typeof n == "number" ? n : 24;
  }, [i, n, r]);
  return /* @__PURE__ */ e(
    To,
    {
      style: {
        padding: a,
        minHeight: "calc(100vh - 64px - 70px)",
        // Adjust for header and footer
        background: o
        // Dynamic background color based on theme
      },
      children: /* @__PURE__ */ e(
        yr,
        {
          fallback: /* @__PURE__ */ e(
            En,
            {
              size: "large",
              style: {
                display: "block",
                margin: "auto",
                marginTop: "20%"
                // Center the spinner vertically
              }
            }
          ),
          children: t || /* @__PURE__ */ e(Dr, {})
        }
      )
    }
  );
}, Ee = 48, zn = "env(safe-area-inset-bottom)", el = (t) => `calc(${t}px + ${zn})`, { Footer: Ao } = de, No = {
  facebook: /* @__PURE__ */ e("i", { className: "fab fa-facebook" }),
  twitter: /* @__PURE__ */ e("i", { className: "fab fa-twitter" }),
  instagram: /* @__PURE__ */ e("i", { className: "fab fa-instagram" }),
  linkedin: /* @__PURE__ */ e("i", { className: "fab fa-linkedin" })
  // Add more icons as needed
}, Lo = ({
  text: t = "© 2025 DigiWedge. All rights reserved.",
  style: n,
  socialMedia: r = [],
  bgColor: o,
  borderColor: i,
  highlightColor: a,
  themeMode: l,
  brandName: s = "Tee Time",
  brandDescription: c = "Book tee times, discover golf clubs, and enjoy exclusive deals. Your perfect round starts here.",
  quickLinks: u = [
    { label: "Find Clubs", href: "/clubs" },
    { label: "Featured Deals", href: "/specials" },
    { label: "About Us", href: "/about" },
    { label: "Contact", href: "/contact" },
    { label: "FAQ", href: "/faq" }
  ],
  contactEmail: h = "support@teetime.com",
  contactPhone: f = "+1 234 567 890",
  showNewsletter: A = !0,
  newsletterTitle: x = "Subscribe to our Newsletter",
  newsletterPlaceholder: y = "Your email",
  newsletterButtonLabel: k = "Subscribe"
}) => {
  const { token: v } = J.useToken(), E = l ?? "light", b = l != null ? J.getDesignToken({
    algorithm: E === "dark" ? J.darkAlgorithm : J.defaultAlgorithm
  }) : v, O = o ?? b.colorBgContainer, B = i ?? b.colorSplit ?? b.colorBorderSecondary, H = b.colorText, C = b.colorTextDescription ?? b.colorTextSecondary ?? H, S = a ?? b.colorPrimary, P = b.colorBgLayout, p = `clamp(${b.paddingSM}px, 6vw, ${b.paddingXL}px)`, M = u ?? [], D = M.length > 0, G = !!(h || f), R = {
    textAlign: "center",
    padding: 0,
    marginTop: b.marginXL,
    backgroundColor: O,
    color: H,
    borderTop: `1px solid ${B}`,
    ...n
  }, X = /* @__PURE__ */ d(Ao, { style: { ...R }, children: [
    /* @__PURE__ */ d(
      "div",
      {
        style: {
          width: "100%",
          padding: `24px ${p}`,
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "space-between",
          alignItems: "flex-start",
          gap: b.marginLG,
          minHeight: Ee
        },
        children: [
          /* @__PURE__ */ d("div", { style: { marginBottom: b.marginMD, textAlign: "left", maxWidth: 320 }, children: [
            /* @__PURE__ */ e(
              "div",
              {
                style: {
                  fontWeight: 700,
                  fontSize: 22,
                  color: S,
                  marginBottom: b.marginSM
                },
                children: s
              }
            ),
            /* @__PURE__ */ e("div", { style: { color: C, fontSize: 14 }, children: c })
          ] }),
          D && /* @__PURE__ */ d("div", { style: { marginBottom: b.marginMD, textAlign: "left" }, children: [
            /* @__PURE__ */ e("div", { style: { fontWeight: 600, marginBottom: b.marginSM }, children: "Quick Links" }),
            /* @__PURE__ */ e("div", { style: { display: "flex", flexDirection: "column", gap: 4 }, children: M.map((K) => /* @__PURE__ */ e("a", { href: K.href, style: { color: H }, children: K.label }, K.href)) })
          ] }),
          G && /* @__PURE__ */ d("div", { style: { marginBottom: b.marginMD, textAlign: "left" }, children: [
            /* @__PURE__ */ e("div", { style: { fontWeight: 600, marginBottom: b.marginSM }, children: "Contact" }),
            /* @__PURE__ */ d("div", { style: { fontSize: 14 }, children: [
              h && /* @__PURE__ */ d(be, { children: [
                "Email:",
                " ",
                /* @__PURE__ */ e("a", { href: `mailto:${h}`, style: { color: S }, children: h })
              ] }),
              h && f && /* @__PURE__ */ e("br", {}),
              f && /* @__PURE__ */ d(be, { children: [
                "Phone:",
                " ",
                /* @__PURE__ */ e("a", { href: `tel:${f.replace(/\s/g, "")}`, style: { color: H }, children: f })
              ] })
            ] }),
            /* @__PURE__ */ e("div", { style: { marginTop: b.marginSM }, children: r.length > 0 ? r.map(
              (K) => K.href ? /* @__PURE__ */ e(
                "a",
                {
                  href: K.href,
                  "aria-label": K.platform,
                  style: { margin: "0 8px", color: S },
                  children: K.icon || No[K.platform.toLowerCase()]
                },
                K.href
              ) : null
            ) : /* @__PURE__ */ d(be, { children: [
              /* @__PURE__ */ e(
                "a",
                {
                  href: "https://facebook.com",
                  target: "_blank",
                  rel: "noopener noreferrer",
                  "aria-label": "Facebook",
                  style: { margin: "0 8px", color: S },
                  children: /* @__PURE__ */ e("i", { className: "fab fa-facebook" })
                }
              ),
              /* @__PURE__ */ e(
                "a",
                {
                  href: "https://twitter.com",
                  target: "_blank",
                  rel: "noopener noreferrer",
                  "aria-label": "Twitter",
                  style: { margin: "0 8px", color: S },
                  children: /* @__PURE__ */ e("i", { className: "fab fa-twitter" })
                }
              ),
              /* @__PURE__ */ e(
                "a",
                {
                  href: "https://instagram.com",
                  target: "_blank",
                  rel: "noopener noreferrer",
                  "aria-label": "Instagram",
                  style: { margin: "0 8px", color: S },
                  children: /* @__PURE__ */ e("i", { className: "fab fa-instagram" })
                }
              )
            ] }) })
          ] }),
          A && /* @__PURE__ */ d("div", { style: { marginBottom: b.marginMD, textAlign: "left" }, children: [
            /* @__PURE__ */ e("div", { style: { fontWeight: 600, marginBottom: b.marginSM }, children: x }),
            /* @__PURE__ */ d(
              "form",
              {
                onSubmit: (K) => K.preventDefault(),
                style: { display: "flex", gap: b.marginSM, flexWrap: "wrap" },
                children: [
                  /* @__PURE__ */ e(
                    "input",
                    {
                      type: "email",
                      placeholder: y,
                      "aria-label": y,
                      style: {
                        flex: 1,
                        padding: 6,
                        borderRadius: b.borderRadius,
                        border: `1px solid ${b.colorBorder}`,
                        background: b.colorBgContainer,
                        color: H
                      }
                    }
                  ),
                  /* @__PURE__ */ e(
                    "button",
                    {
                      type: "submit",
                      style: {
                        background: S,
                        color: b.colorTextLightSolid,
                        border: "none",
                        borderRadius: b.borderRadius,
                        padding: "6px 14px",
                        fontWeight: 600,
                        cursor: "pointer"
                      },
                      children: k
                    }
                  )
                ]
              }
            )
          ] })
        ]
      }
    ),
    /* @__PURE__ */ e(
      "div",
      {
        style: {
          color: C,
          fontSize: 13,
          padding: "16px 0",
          width: "100%",
          backgroundColor: P
        },
        children: /* @__PURE__ */ d(
          "div",
          {
            style: {
              width: "100%",
              padding: `0 ${p}`,
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              flexWrap: "wrap",
              rowGap: b.marginSM,
              whiteSpace: "nowrap"
            },
            children: [
              /* @__PURE__ */ e("p", { style: { margin: 0 }, children: t }),
              /* @__PURE__ */ e("div", { style: { width: "100%" } }),
              /* @__PURE__ */ d("div", { style: { display: "flex", gap: 16, whiteSpace: "nowrap" }, children: [
                /* @__PURE__ */ e("a", { href: "/terms", style: { color: C }, children: "Terms of Service" }),
                /* @__PURE__ */ e("a", { href: "/privacy", style: { color: C }, children: "Privacy Policy" })
              ] })
            ]
          }
        )
      }
    )
  ] });
  return l ? /* @__PURE__ */ e(
    Pn,
    {
      theme: { algorithm: E === "dark" ? J.darkAlgorithm : J.defaultAlgorithm },
      children: X
    }
  ) : X;
}, tl = Lo, { Footer: Io } = de, mn = {
  dev: { color: "geekblue", label: "DEV" },
  uat: { color: "gold", label: "UAT" },
  prod: { color: "success", label: "PROD" }
}, Do = 7, nl = ({
  orgName: t,
  env: n,
  version: r,
  commit: o,
  syncInfo: i,
  links: a,
  bordered: l = !0
}) => {
  const { token: s } = J.useToken(), c = s.colorBgContainer, u = s.colorSplit ?? s.colorBorderSecondary, h = s.colorTextDescription ?? s.colorTextSecondary, f = `clamp(${s.paddingSM}px, 5vw, ${s.paddingLG}px)`, A = i ? i.tooltip ? /* @__PURE__ */ e(Mn, { title: i.tooltip, placement: "top", children: /* @__PURE__ */ e($.Text, { style: { color: h }, children: i.label }) }) : /* @__PURE__ */ e($.Text, { style: { color: h }, children: i.label }) : null, x = r ? /* @__PURE__ */ d($.Text, { style: { color: h }, children: [
    "v",
    r
  ] }) : null, y = o ? /* @__PURE__ */ e($.Text, { code: !0, style: { color: h }, children: o.slice(0, Do) }) : null, k = a?.length ? /* @__PURE__ */ e(Y, { size: s.marginSM, wrap: !0, children: a.map((v) => /* @__PURE__ */ e($.Link, { href: v.href, style: { color: s.colorPrimary }, children: v.label }, v.href)) }) : null;
  return /* @__PURE__ */ e(
    Io,
    {
      style: {
        background: c,
        borderTop: l ? `1px solid ${u}` : void 0,
        padding: `${s.paddingSM}px ${f}`
      },
      children: /* @__PURE__ */ d(
        "div",
        {
          style: {
            display: "flex",
            flexWrap: "wrap",
            alignItems: "center",
            justifyContent: "space-between",
            gap: s.marginSM,
            minHeight: Ee
          },
          children: [
            /* @__PURE__ */ d(Y, { size: s.marginSM, wrap: !0, children: [
              /* @__PURE__ */ e($.Text, { strong: !0, children: t ?? "DigiWedge Admin" }),
              A
            ] }),
            /* @__PURE__ */ d(Y, { size: s.marginSM, wrap: !0, children: [
              n ? /* @__PURE__ */ e(Se, { color: mn[n].color, children: mn[n].label }) : null,
              x,
              y,
              k
            ] })
          ]
        }
      )
    }
  );
}, { Footer: Eo } = de, rl = ({
  primary: t,
  secondary: n,
  status: r,
  sticky: o = !0,
  safeArea: i = !0
}) => {
  const { token: a } = J.useToken(), l = a.colorBgContainer, s = a.colorSplit ?? a.colorBorderSecondary, c = i ? `calc(${a.paddingSM}px + ${zn})` : `${a.paddingSM}px`;
  return /* @__PURE__ */ e(
    Eo,
    {
      style: {
        background: l,
        borderTop: `1px solid ${s}`,
        padding: `${a.paddingSM}px clamp(${a.paddingSM}px, 6vw, ${a.paddingLG}px) ${c}`,
        position: o ? "sticky" : "static",
        bottom: o ? 0 : void 0,
        zIndex: o ? a.zIndexPopupBase : void 0
      },
      children: /* @__PURE__ */ d(
        "div",
        {
          style: {
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            flexWrap: "wrap",
            gap: a.marginSM,
            minHeight: Ee
          },
          children: [
            /* @__PURE__ */ e("div", { style: { minHeight: 24, flex: 1 }, children: r ? typeof r == "string" ? /* @__PURE__ */ e($.Text, { type: "secondary", children: r }) : r : null }),
            /* @__PURE__ */ d(Y, { size: a.marginSM, wrap: !0, children: [
              n?.map((u) => /* @__PURE__ */ e(U, { onClick: u.onClick, children: u.label }, u.label)),
              /* @__PURE__ */ e(
                U,
                {
                  type: "primary",
                  onClick: t.onClick,
                  disabled: t.disabled,
                  loading: t.loading,
                  children: t.label
                }
              )
            ] })
          ]
        }
      )
    }
  );
}, { Footer: Po } = de, ol = ({
  selectedCount: t = 0,
  bulkActions: n,
  pagination: r,
  extra: o,
  bordered: i = !0
}) => {
  const { token: a } = J.useToken(), l = a.colorSplit ?? a.colorBorderSecondary, s = a.colorBgContainer, c = t > 0, [u, h] = I(!1), [f, A] = I(-1), x = Ie(null), y = Ie(null), k = Ie([]);
  ie(() => {
    !c && u && h(!1);
  }, [c, u]);
  const v = Z(() => n?.length ? n.filter(
    (C) => !!(C?.key && C?.label && typeof C.onClick == "function")
  ) : [], [n]), E = v.length > 0, b = c && E, O = ke(() => {
    b && h((C) => !C);
  }, [b]);
  ie(() => {
    if (!u) {
      A(-1);
      return;
    }
    v.length > 0 && (A(0), k.current[0]?.focus());
    const C = (P) => {
      const p = P.target;
      p && (y.current?.contains(p) || x.current?.contains(p) || h(!1));
    }, S = (P) => {
      P.key === "Escape" && (h(!1), x.current?.focus());
    };
    return document.addEventListener("mousedown", C), document.addEventListener("keydown", S), () => {
      document.removeEventListener("mousedown", C), document.removeEventListener("keydown", S);
    };
  }, [u, v.length]);
  const B = ke((C) => {
    h(!1), C.onClick();
  }, []), H = ke(
    (C, S) => {
      const P = v.length;
      let p = S;
      switch (C.key) {
        case "ArrowDown":
          C.preventDefault(), p = (S + 1) % P;
          break;
        case "ArrowUp":
          C.preventDefault(), p = (S - 1 + P) % P;
          break;
        case "Home":
          C.preventDefault(), p = 0;
          break;
        case "End":
          C.preventDefault(), p = P - 1;
          break;
        case "Tab":
          h(!1);
          return;
        default:
          return;
      }
      A(p), k.current[p]?.focus();
    },
    [v.length]
  );
  return /* @__PURE__ */ e(
    Po,
    {
      style: {
        background: s,
        borderTop: i ? `1px solid ${l}` : void 0,
        padding: `${a.paddingSM}px clamp(${a.paddingSM}px, 5vw, ${a.paddingLG}px)`
      },
      children: /* @__PURE__ */ d(
        "div",
        {
          style: {
            display: "flex",
            flexWrap: "wrap",
            alignItems: "center",
            justifyContent: "space-between",
            gap: a.marginSM,
            minHeight: Ee
          },
          children: [
            /* @__PURE__ */ d(Y, { size: a.marginSM, wrap: !0, children: [
              c ? /* @__PURE__ */ d($.Text, { strong: !0, children: [
                t,
                " selected"
              ] }) : /* @__PURE__ */ e($.Text, { type: "secondary", children: "No rows selected" }),
              E ? /* @__PURE__ */ d("div", { style: { position: "relative" }, children: [
                /* @__PURE__ */ e(
                  U,
                  {
                    ref: x,
                    disabled: !b,
                    onClick: O,
                    "aria-haspopup": "menu",
                    "aria-expanded": b ? u : void 0,
                    children: "Bulk actions"
                  }
                ),
                u ? /* @__PURE__ */ e(
                  "div",
                  {
                    ref: y,
                    role: "menu",
                    "aria-label": "Bulk actions",
                    style: {
                      position: "absolute",
                      top: a.paddingLG,
                      left: 0,
                      background: s,
                      border: `1px solid ${l}`,
                      borderRadius: a.borderRadiusLG,
                      boxShadow: a.boxShadowSecondary,
                      minWidth: 160,
                      zIndex: a.zIndexPopupBase,
                      display: "flex",
                      flexDirection: "column"
                    },
                    children: v.map((C, S) => /* @__PURE__ */ e(
                      "button",
                      {
                        ref: (P) => {
                          k.current[S] = P;
                        },
                        type: "button",
                        role: "menuitem",
                        tabIndex: f === S ? 0 : -1,
                        onClick: () => B(C),
                        onKeyDown: (P) => H(P, S),
                        style: {
                          width: "100%",
                          padding: `${a.paddingXS}px ${a.paddingSM}px`,
                          background: "transparent",
                          border: "none",
                          textAlign: "left",
                          cursor: "pointer"
                        },
                        children: C.label
                      },
                      C.key
                    ))
                  }
                ) : null
              ] }) : null
            ] }),
            /* @__PURE__ */ d(Y, { size: a.marginSM, wrap: !0, children: [
              o,
              r
            ] })
          ]
        }
      )
    }
  );
}, { Footer: Mo } = de, hn = (t) => t?.name ?? "—", il = ({
  org: t,
  site: n,
  region: r,
  locale: o,
  impersonating: i,
  links: a
}) => {
  const { token: l } = J.useToken();
  return /* @__PURE__ */ e(
    Mo,
    {
      style: {
        background: l.colorBgContainer,
        borderTop: `1px solid ${l.colorSplit ?? l.colorBorderSecondary}`,
        padding: `${l.paddingSM}px clamp(${l.paddingSM}px, 5vw, ${l.paddingXL}px)`
      },
      children: /* @__PURE__ */ d(
        "div",
        {
          style: {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "wrap",
            gap: l.marginSM,
            minHeight: Ee
          },
          children: [
            /* @__PURE__ */ d(Y, { size: l.marginSM, wrap: !0, children: [
              /* @__PURE__ */ e($.Text, { strong: !0, children: "Org:" }),
              /* @__PURE__ */ e($.Text, { children: hn(t) }),
              /* @__PURE__ */ e($.Text, { strong: !0, children: "Site:" }),
              /* @__PURE__ */ e($.Text, { children: hn(n) }),
              r ? /* @__PURE__ */ e(Se, { color: "blue", bordered: !1, children: r.toUpperCase() }) : null,
              o ? /* @__PURE__ */ e(Se, { color: "purple", bordered: !1, children: o }) : null
            ] }),
            /* @__PURE__ */ d(Y, { size: l.marginSM, wrap: !0, align: "center", children: [
              i ? /* @__PURE__ */ d(Se, { color: "orange", bordered: !1, children: [
                "Impersonating ",
                i.name
              ] }) : null,
              a?.map((s) => /* @__PURE__ */ d($.Link, { href: s.href, style: { color: l.colorPrimary }, children: [
                s.icon,
                s.icon ? /* @__PURE__ */ e("span", { style: { marginLeft: 4 }, children: s.label }) : s.label
              ] }, s.href))
            ] })
          ]
        }
      )
    }
  );
}, { Footer: Uo } = de, Ro = {
  ok: "success",
  warn: "warning",
  err: "error"
}, al = ({ metrics: t, legal: n }) => {
  const { token: r } = J.useToken();
  return /* @__PURE__ */ e(
    Uo,
    {
      style: {
        background: r.colorBgContainer,
        borderTop: `1px solid ${r.colorSplit ?? r.colorBorderSecondary}`,
        padding: `${r.paddingSM}px clamp(${r.paddingSM}px, 6vw, ${r.paddingXL}px)`
      },
      children: /* @__PURE__ */ d(
        Y,
        {
          orientation: "vertical",
          size: r.marginSM,
          style: { width: "100%", minHeight: Ee },
          children: [
            /* @__PURE__ */ e(Y, { size: r.marginSM, wrap: !0, children: t.map((o, i) => /* @__PURE__ */ d(
              Se,
              {
                color: o.status ? Ro[o.status] : void 0,
                bordered: !1,
                style: { paddingInline: r.paddingXS, fontWeight: 500 },
                children: [
                  o.label,
                  ": ",
                  o.value
                ]
              },
              `${o.label}-${i}`
            )) }),
            n ? /* @__PURE__ */ e($.Text, { type: "secondary", style: { fontSize: 12 }, children: n }) : null
          ]
        }
      )
    }
  );
}, { Footer: Bo } = de, sl = ({
  text: t = "© DigiWedge. All rights reserved.",
  links: n,
  align: r = "spread"
}) => {
  const { token: o } = J.useToken(), i = r === "center" ? "center" : "space-between", a = `clamp(${o.paddingSM}px, 4vw, ${o.paddingLG}px)`, l = `${o.paddingXS}px`;
  return /* @__PURE__ */ e(
    Bo,
    {
      style: {
        background: o.colorBgContainer,
        borderTop: `1px solid ${o.colorSplit ?? o.colorBorderSecondary}`,
        padding: `${l} ${a}`
      },
      children: /* @__PURE__ */ d(
        "div",
        {
          style: {
            display: "flex",
            justifyContent: i,
            alignItems: "center",
            flexWrap: "wrap",
            gap: o.marginSM,
            minHeight: Ee,
            color: o.colorTextDescription ?? o.colorTextSecondary,
            fontSize: 12
          },
          children: [
            /* @__PURE__ */ e($.Text, { type: "secondary", children: t }),
            n?.length ? /* @__PURE__ */ e(Y, { size: o.marginSM, wrap: !0, children: n.map((s) => /* @__PURE__ */ e($.Link, { href: s.href, style: { color: o.colorPrimary }, children: s.label }, s.href)) }) : null
          ]
        }
      )
    }
  );
};
function Fo({
  navItems: t,
  selectedNavKey: n,
  isTestEnv: r,
  onNavigate: o
}) {
  const i = z.useMemo(() => t ?? [], [t]), a = z.useMemo(() => Hn(i), [i]), l = i.some(Boolean);
  return /* @__PURE__ */ d(be, { children: [
    l ? /* @__PURE__ */ e(
      Un,
      {
        mode: "horizontal",
        items: i,
        selectedKeys: n ? [n] : [],
        onClick: ({ key: s }) => o(s),
        style: {
          flex: 1,
          minWidth: 0,
          background: "transparent",
          borderBottom: "none"
        }
      }
    ) : /* @__PURE__ */ e("div", { style: { flex: 1, minWidth: 0 } }),
    r && a.length ? /* @__PURE__ */ e("ul", { style: $o, "aria-hidden": !0, children: a.map((s) => /* @__PURE__ */ e("li", { children: s.label }, s.key)) }) : null
  ] });
}
const $o = {
  position: "absolute",
  width: 1,
  height: 1,
  padding: 0,
  margin: -1,
  overflow: "hidden",
  clip: "rect(0, 0, 0, 0)",
  whiteSpace: "nowrap",
  border: 0
};
function Hn(t) {
  if (!t?.length)
    return [];
  const n = [];
  for (const r of t) {
    if (!r || typeof r != "object")
      continue;
    const o = "key" in r && r.key != null ? String(r.key) : void 0, i = "label" in r ? r.label : void 0;
    typeof i == "string" && n.push({ key: o ?? i, label: i }), "children" in r && Array.isArray(r.children) && n.push(...Hn(r.children));
  }
  return n;
}
function Oo({
  onNavigate: t,
  token: n,
  user: r,
  userMenuItems: o,
  userProfilePath: i
}) {
  const a = z.useMemo(() => Wo(o), [o]), l = a.items, s = a.autoNavigateKeys, c = l.length > 0, u = i?.trim(), h = !!u, f = z.useRef(null), A = z.useRef(null), [x, y] = z.useState(!1), k = z.useCallback(() => {
    const S = f.current;
    S && typeof S.focus == "function" && S.focus();
  }, []), v = z.useCallback(
    (S) => {
      y(!1), S?.restoreFocus && requestAnimationFrame(() => {
        k();
      });
    },
    [k]
  ), E = z.useCallback(() => {
    c && y((S) => !S);
  }, [c]), b = z.useCallback(
    (S) => {
      if (!c) {
        u && (S.key === "Enter" || S.key === " ") && (S.preventDefault(), t(u));
        return;
      }
      (S.key === "Enter" || S.key === " ") && (S.preventDefault(), E());
    },
    [c, t, u, E]
  ), O = z.useCallback(
    (S) => {
      const P = S.target;
      if (!c && u && P?.closest("[data-user-profile-trigger]")) {
        S.preventDefault(), v(), t(u);
        return;
      }
      c && E();
    },
    [v, c, t, u, E]
  ), B = z.useCallback(
    (S, P) => {
      if (v(), !S || typeof S != "object" || !("key" in S) || S.key == null)
        return;
      const p = String(S.key);
      if ("onClick" in S && typeof S.onClick == "function") {
        const M = {
          key: p,
          keyPath: [p],
          item: P.currentTarget,
          domEvent: P
        };
        S.onClick(M);
      }
      P.defaultPrevented || !s.has(p) || t(p);
    },
    [v, t, s]
  );
  z.useEffect(() => {
    if (!x)
      return;
    const S = (P) => {
      const p = P.target;
      p && (A.current?.contains(p) || f.current?.contains(p) || v());
    };
    return document.addEventListener("mousedown", S), () => {
      document.removeEventListener("mousedown", S);
    };
  }, [v, x]), z.useEffect(() => {
    if (!x)
      return;
    const S = (P) => {
      P.key === "Escape" && (P.preventDefault(), v({ restoreFocus: !0 }));
    };
    return document.addEventListener("keydown", S), () => {
      document.removeEventListener("keydown", S);
    };
  }, [v, x]);
  const H = r.avatarUrl ? "transparent" : "#4caf50", C = r.name[0]?.toUpperCase() ?? "UNK";
  return /* @__PURE__ */ d("div", { style: { position: "relative" }, children: [
    /* @__PURE__ */ d(
      Y,
      {
        ref: f,
        onClick: O,
        onKeyDown: b,
        role: "button",
        tabIndex: c || h ? 0 : -1,
        "aria-label": "User menu trigger",
        "aria-haspopup": "menu",
        "aria-expanded": c ? x : void 0,
        style: {
          cursor: c || h ? "pointer" : "default",
          alignItems: "center"
        },
        children: [
          /* @__PURE__ */ e(
            Rn,
            {
              "data-user-profile-trigger": h ? "true" : void 0,
              src: r.avatarUrl,
              style: {
                backgroundColor: H,
                border: `2px solid ${n.colorPrimary}`
              },
              "aria-label": "User menu",
              children: C
            }
          ),
          /* @__PURE__ */ e(Pr, { style: { fontSize: 12, color: n.colorText } })
        ]
      }
    ),
    x ? /* @__PURE__ */ e(
      zo,
      {
        items: l,
        menuRef: A,
        onItemClick: B,
        token: n
      }
    ) : null
  ] });
}
function zo({
  items: t,
  menuRef: n,
  onItemClick: r,
  token: o
}) {
  return /* @__PURE__ */ e(
    "div",
    {
      ref: n,
      role: "menu",
      "aria-label": "User actions",
      style: {
        position: "absolute",
        top: "calc(100% + 4px)",
        right: 0,
        background: o.colorBgElevated,
        border: `1px solid ${o.colorBorder}`,
        borderRadius: o.borderRadiusLG,
        boxShadow: o.boxShadowSecondary,
        minWidth: 180,
        zIndex: o.zIndexPopupBase,
        overflow: "hidden"
      },
      children: /* @__PURE__ */ e("ul", { role: "none", style: { listStyle: "none", margin: 0, padding: 4 }, children: t.map((i) => Ho(i, r, o)) })
    }
  );
}
function Ho(t, n, r) {
  if (!t || typeof t != "object" || !("key" in t))
    return null;
  const o = String(t.key), i = "label" in t ? t.label : o, a = "disabled" in t && t.disabled === !0;
  return /* @__PURE__ */ e("li", { role: "none", children: /* @__PURE__ */ e(
    "button",
    {
      type: "button",
      role: "menuitem",
      disabled: a,
      onClick: (l) => n(t, l),
      style: {
        width: "100%",
        border: 0,
        background: "transparent",
        color: r.colorText,
        cursor: a ? "not-allowed" : "pointer",
        font: "inherit",
        padding: "8px 12px",
        textAlign: "left"
      },
      children: i
    }
  ) }, o);
}
function Wo(t) {
  if (!t?.length)
    return { items: [], autoNavigateKeys: /* @__PURE__ */ new Set() };
  const n = [], r = /* @__PURE__ */ new Set();
  for (const o of t) {
    if (!o || typeof o != "object" || !("key" in o) || o.key == null || !("label" in o))
      continue;
    const i = o.label;
    if (i == null)
      continue;
    const a = String(o.key), l = { ...o, key: a, label: i }, s = "onClick" in o && typeof o.onClick == "function";
    n.push(l), !z.isValidElement(i) && !s && r.add(a);
  }
  return { items: n, autoNavigateKeys: r };
}
function Vo({
  user: t,
  userMenuItems: n,
  notificationsCount: r,
  notificationsPath: o,
  rightExtra: i,
  buttonColor: a,
  userProfilePath: l,
  token: s,
  onNavigate: c
}) {
  return /* @__PURE__ */ d(Y, { size: "middle", style: { marginLeft: "auto", display: "flex", alignItems: "center" }, children: [
    i,
    t?.name ? /* @__PURE__ */ e(
      jo,
      {
        user: t,
        userMenuItems: n,
        notificationsCount: r,
        notificationsPath: o,
        rightExtra: i,
        buttonColor: a,
        userProfilePath: l,
        token: s,
        onNavigate: c
      }
    ) : /* @__PURE__ */ e(Go, { buttonColor: a, token: s, onNavigate: c })
  ] });
}
function jo({
  user: t,
  userMenuItems: n,
  notificationsCount: r,
  notificationsPath: o,
  rightExtra: i,
  buttonColor: a,
  userProfilePath: l,
  token: s,
  onNavigate: c
}) {
  const u = !i && r !== void 0 ? qo(o) : void 0;
  return /* @__PURE__ */ d(be, { children: [
    u !== void 0 ? /* @__PURE__ */ e(
      kr,
      {
        count: r,
        "aria-label": `${r} notifications`,
        style: { alignSelf: "center" },
        children: /* @__PURE__ */ e(
          U,
          {
            type: "text",
            icon: /* @__PURE__ */ e(Mr, { style: { width: 18, height: 18 } }),
            "aria-label": "Notifications",
            onClick: () => c(u),
            style: {
              color: s.colorText,
              ...a ? { background: a, borderColor: a, color: "#fff" } : {}
            }
          }
        )
      }
    ) : null,
    /* @__PURE__ */ e(
      Oo,
      {
        onNavigate: c,
        token: s,
        user: t,
        userMenuItems: n,
        userProfilePath: l
      }
    )
  ] });
}
function qo(t) {
  const n = t?.trim();
  if (!(!n || !n.startsWith("/") || n.startsWith("//")))
    return n;
}
function Go({
  buttonColor: t,
  token: n,
  onNavigate: r
}) {
  return /* @__PURE__ */ d(be, { children: [
    /* @__PURE__ */ e(
      U,
      {
        type: "link",
        onClick: () => r("/login"),
        className: `header-login-button ${t ? "custom-color" : ""}`,
        style: t ? { color: t } : { color: n.colorPrimary },
        children: "Login"
      }
    ),
    /* @__PURE__ */ e(
      U,
      {
        type: "primary",
        onClick: () => r("/signup"),
        style: t ? { background: t, borderColor: t, color: "#fff" } : {
          background: n.colorPrimary,
          borderColor: n.colorPrimary,
          color: "#fff"
        },
        children: "Sign Up"
      }
    )
  ] });
}
const { Header: Yo } = de, ll = ({
  navItems: t,
  userMenuItems: n,
  notificationsCount: r,
  notificationsPath: o,
  user: i,
  selectedNavKey: a,
  borderColor: l,
  buttonColor: s,
  leftExtra: c,
  rightExtra: u,
  className: h,
  style: f,
  themeMode: A,
  userProfilePath: x
}) => {
  const y = ht(), { token: k } = J.useToken(), v = process.env.NODE_ENV === "test";
  return /* @__PURE__ */ e(
    Yo,
    {
      className: h,
      style: {
        display: "flex",
        alignItems: "center",
        padding: 0,
        transition: "background 0.3s ease",
        borderBottom: `1px solid ${l || k.colorSplit || "#e0e0e0"}`,
        backgroundColor: k.colorBgContainer,
        ...f
      },
      children: /* @__PURE__ */ d(
        "div",
        {
          style: {
            width: "100%",
            display: "flex",
            alignItems: "center",
            gap: 8,
            padding: "0 16px"
          },
          children: [
            c,
            /* @__PURE__ */ e(
              Fo,
              {
                isTestEnv: v,
                navItems: t,
                onNavigate: y,
                selectedNavKey: a
              }
            ),
            /* @__PURE__ */ e(
              Vo,
              {
                buttonColor: s,
                notificationsCount: r,
                notificationsPath: o,
                onNavigate: y,
                rightExtra: u,
                token: k,
                user: i,
                userMenuItems: n,
                userProfilePath: x
              }
            )
          ]
        }
      )
    }
  );
}, Wn = z.memo(
  ({
    themeMode: t = "light",
    size: n = "medium",
    // Defaults align visually with theme: light => light bg, dark => dark bg
    lightLogoSrc: r = 'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="150" height="48"><rect width="150" height="48" fill="%23ffffff"/><text x="75" y="30" font-size="14" text-anchor="middle" fill="%23000000">Light Logo</text></svg>',
    darkLogoSrc: o = 'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="150" height="48"><rect width="150" height="48" fill="%23000000"/><text x="75" y="30" font-size="14" text-anchor="middle" fill="%23ffffff">Dark Logo</text></svg>',
    style: i,
    alt: a
  }) => /* @__PURE__ */ e(
    "img",
    {
      src: t === "dark" ? o : r,
      alt: a ?? `${t === "dark" ? "Dark" : "Light"} Mode Logo`,
      style: {
        ...{
          small: { height: "24px", width: "auto" },
          medium: { height: "48px", width: "auto" },
          large: { height: "72px", width: "auto" }
        }[n],
        ...i
      }
    }
  )
), Ko = 64;
function Qo(t = Ko) {
  return {
    height: `calc(100vh - ${t}px)`,
    maxHeight: `calc(100vh - ${t}px)`,
    position: "sticky",
    top: t,
    alignSelf: "flex-start"
  };
}
const { useBreakpoint: Xo } = Lt, { Sider: Zo } = de, { Text: Jo } = $, cl = ({
  collapsed: t,
  onCollapse: n,
  collapsible: r = !0,
  themeMode: o = "light",
  sidebarItems: i,
  onClick: a,
  selectedKeys: l,
  defaultSelectedKeys: s,
  openKeys: c,
  onOpenChange: u,
  defaultOpenKeys: h = [],
  logo: f,
  style: A,
  className: x,
  menuClassName: y,
  menuStyle: k,
  breakpoint: v = "md",
  width: E = 240,
  collapsedWidth: b = 80,
  testId: O
}) => {
  const { token: B } = J.useToken(), H = Xo(), C = z.useRef(void 0), S = process.env.NODE_ENV === "test";
  z.useEffect(() => {
    const X = H[v];
    r && C.current !== void 0 && C.current !== X && n?.(!X), C.current = X;
  }, [H, v, r, n]);
  const P = z.useCallback(() => {
    n?.(!t);
  }, [t, n]), p = z.useMemo(() => Vn(i), [i]), M = ["digiwedge-sidebar", x].filter(Boolean).join(" "), D = ["digiwedge-sidebar-menu", y].filter(Boolean).join(" "), G = z.useMemo(
    () => ({
      inherit: !0,
      components: {
        Menu: qr(o)
      }
    }),
    [o]
  ), R = z.useMemo(
    () => ({
      theme: o,
      mode: "inline",
      items: i,
      onClick: a,
      selectedKeys: l,
      defaultSelectedKeys: s,
      openKeys: c,
      onOpenChange: u,
      defaultOpenKeys: h,
      className: D,
      style: {
        flex: "1 1 auto",
        minHeight: 0,
        overflowX: "hidden",
        overflowY: "auto",
        ...k
      }
    }),
    [
      o,
      i,
      a,
      l,
      s,
      c,
      u,
      h,
      D,
      k
    ]
  );
  return /* @__PURE__ */ e(Pn, { theme: G, children: /* @__PURE__ */ d(
    Zo,
    {
      collapsible: r,
      collapsed: t,
      theme: o,
      trigger: null,
      width: E,
      collapsedWidth: b,
      "data-testid": O,
      style: {
        // Backward-compatible default geometry: a sticky, viewport-bounded shell so that
        // wrapper consumers which do NOT pass `style` (e.g. MessagingSidebar / messaging-admin)
        // keep their sticky scroll behavior. App shells that own their geometry override this
        // via the `style` prop, which is spread last. See #19560.
        ...Qo(),
        minHeight: 0,
        overflow: "hidden",
        // Use token to dynamically adjust the background per theme
        background: B.colorBgContainer,
        paddingBottom: B.paddingLG,
        ...A
      },
      className: M,
      children: [
        /* @__PURE__ */ e(
          "div",
          {
            className: "digiwedge-sidebar-logo",
            style: {
              padding: B.padding,
              borderBottom: `1px solid ${B.colorBorder}`
            },
            children: f || /* @__PURE__ */ e(Jo, { strong: !0, children: t ? "Logo" : "Application Name" })
          }
        ),
        /* @__PURE__ */ e(Un, { ...R }),
        S && p.length ? /* @__PURE__ */ e("ul", { style: ei, "aria-hidden": !0, children: p.map((X) => /* @__PURE__ */ e("li", { children: X.label }, X.key)) }) : null,
        r ? /* @__PURE__ */ e(
          U,
          {
            type: "text",
            onClick: P,
            icon: t ? /* @__PURE__ */ e(Ur, {}) : /* @__PURE__ */ e(Rr, {}),
            className: "digiwedge-sidebar-toggle",
            style: {
              width: "100%",
              borderRadius: 0,
              borderTop: `1px solid ${B.colorBorder}`
            },
            "aria-label": t ? "Expand sidebar" : "Collapse sidebar"
          }
        ) : null
      ]
    }
  ) });
}, ei = {
  position: "absolute",
  width: 1,
  height: 1,
  padding: 0,
  margin: -1,
  overflow: "hidden",
  clip: "rect(0, 0, 0, 0)",
  whiteSpace: "nowrap",
  border: 0
};
function Vn(t) {
  if (!t?.length)
    return [];
  const n = [];
  for (const r of t) {
    if (!r || typeof r != "object")
      continue;
    const o = "key" in r && r.key != null ? String(r.key) : void 0, i = "label" in r ? r.label : void 0;
    typeof i == "string" && n.push({ key: o ?? i, label: i }), "children" in r && Array.isArray(r.children) && n.push(...Vn(r.children));
  }
  return n;
}
function Fe(t, n) {
  const r = n ? new Set(n) : void 0, o = [];
  for (const i of t)
    r && !r.has(i) || o.includes(i) || o.push(i);
  return o;
}
function gn(t, n) {
  if (typeof window > "u")
    return { found: !1, hadNonStringEntries: !1, hadPersistedEntries: !1, keys: [] };
  try {
    const r = window.localStorage.getItem(t);
    if (!r)
      return { found: !1, hadNonStringEntries: !1, hadPersistedEntries: !1, keys: [] };
    const o = JSON.parse(r);
    if (!Array.isArray(o))
      return { found: !1, hadNonStringEntries: !1, hadPersistedEntries: !1, keys: [] };
    const i = o.filter((a) => typeof a == "string");
    return {
      found: !0,
      hadNonStringEntries: i.length !== o.length,
      hadPersistedEntries: o.length > 0,
      keys: Fe(i, n)
    };
  } catch {
    return { found: !1, hadNonStringEntries: !1, hadPersistedEntries: !1, keys: [] };
  }
}
function fn(t, n) {
  if (!(typeof window > "u"))
    try {
      window.localStorage.setItem(t, JSON.stringify(n));
    } catch {
    }
}
function pn(t, n) {
  return t.length === n.length && t.every((r, o) => r === n[o]);
}
function dl({
  storageKey: t,
  defaultOpenKeys: n,
  validOpenKeys: r
}) {
  const [o, i] = z.useState(() => {
    const l = gn(t, r), s = Fe(n, r);
    return l.found ? l.hadPersistedEntries && l.keys.length === 0 ? s : l.keys : s;
  });
  z.useEffect(() => {
    i((s) => {
      const c = Fe(s, r);
      return pn(s, c) ? s : c;
    });
    const l = gn(t, void 0);
    if (l.found) {
      const s = Fe(n, r), c = Fe(l.keys, r), u = l.hadPersistedEntries && c.length === 0 ? s : c;
      (l.hadNonStringEntries || !pn(l.keys, u)) && fn(t, u);
    }
  }, [n, t, r]);
  const a = z.useCallback(
    (l) => {
      const s = Fe(l, r);
      i(s), fn(t, s);
    },
    [t, r]
  );
  return [o, a];
}
const ti = {
  DRAFT: "default",
  POSTED: "processing",
  PAID: "success",
  OVERDUE: "error",
  VOID: "warning",
  ISSUED: "default",
  SENT: "default",
  PART_PAID: "default",
  REFUNDED: "default"
}, ut = ({ status: t }) => /* @__PURE__ */ e(Se, { color: ti[t], className: "px-2 text-xs font-medium", children: t }), ul = ({ label: t, color: n, closable: r = !1, onClose: o }) => /* @__PURE__ */ e(Se, { color: n, closable: r, onClose: o, className: "px-2 text-xs font-medium", children: t }), { Text: ni } = $, Pt = (t, n = "ZAR", r = !0, o) => {
  const i = o ?? (typeof navigator < "u" ? navigator.language : "en-US"), a = Number(t), l = Math.abs(a), s = {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }, u = new Intl.NumberFormat(i, {
    ...s,
    style: r ? "currency" : "decimal",
    currency: n,
    currencyDisplay: "narrowSymbol"
  }).format(l), h = r ? u : `${u} ${n}`;
  return `${a < 0 ? "−" : ""}${h}`;
}, fe = ({
  amount: t,
  currency: n = "ZAR",
  showSymbol: r = !0,
  className: o
}) => {
  const a = Number(t) < 0, l = Pt(t, n, r);
  return /* @__PURE__ */ e(ni, { className: o, type: a ? "danger" : void 0, strong: a, children: l });
};
te.extend(Kr);
te.extend(Yr);
te.extend(Zr);
te.extend(Xr);
te.extend(Jr);
te.extend(eo);
te.extend(Qr);
const { RangePicker: ri } = Bn, oi = () => {
  const t = te(), n = t.startOf("week"), r = t.endOf("week"), o = t.startOf("month"), i = t.endOf("month"), a = t.month(), l = t.year(), s = a >= 6 ? te(`${l}-07-01`) : te(`${l - 1}-07-01`), c = s.add(1, "year").subtract(1, "day");
  return [
    { label: "📅 Today", value: [t, t] },
    {
      label: "📅 This Week",
      value: [n, r]
    },
    {
      label: "📅 This Month",
      value: [o, i]
    },
    { label: "📅 Financial Year", value: [s, c] }
  ];
}, jn = ({
  value: t,
  onChange: n,
  presets: r = !0,
  allowClear: o = !1,
  disabled: i,
  className: a,
  open: l,
  "data-testid": s
}) => {
  const [c, u] = I([
    t?.[0] ?? null,
    t?.[1] ?? null
  ]);
  ie(() => {
    t && u(t);
  }, [t]);
  const h = (x, y) => {
    const v = ((E) => !!E && typeof E == "object" && "range" in E && E.range !== void 0)(y) ? y.range : void 0;
    return v === "start" && c[1] ? x.isAfter(c[1], "day") : v === "end" && c[0] ? x.isBefore(c[0], "day") : !1;
  };
  return /* @__PURE__ */ e(
    ri,
    {
      value: t ?? c,
      onCalendarChange: (x) => {
        u([x?.[0] ?? null, x?.[1] ?? null]);
      },
      onChange: (x) => {
        if (!x) {
          o && (u([null, null]), n?.([null, null]));
          return;
        }
        let [y, k] = [x[0] ?? null, x[1] ?? null];
        y && k ? (y.isAfter(k) && ([y, k] = [k, y]), u([y, k]), n?.([y, k])) : o && (u([y ?? null, k ?? null]), n?.([y ?? null, k ?? null]));
      },
      presets: r ? oi() : void 0,
      allowClear: o,
      disabled: i,
      className: a,
      disabledDate: h,
      open: l,
      "data-testid": s
    }
  );
}, ii = ({
  x: t,
  y: n,
  width: r,
  height: o,
  payload: i,
  patternId: a,
  colorMap: l,
  onEdit: s,
  highlightColor: c,
  activeId: u,
  setActiveId: h,
  formatDate: f
}) => {
  if (!i || typeof t != "number" || typeof n != "number" || typeof r != "number" || typeof o != "number")
    return null;
  const A = o * 0.6, x = n + (o - A) / 2, y = i.status === "OVERLAP" ? `url(#${a})` : l[i.status], k = /* @__PURE__ */ e(
    "rect",
    {
      x: t,
      y: x,
      width: r,
      height: A,
      fill: y,
      stroke: u === i.id ? c : void 0,
      strokeWidth: u === i.id ? 2 : 0,
      "data-testid": `bar-${i.id}`
    }
  );
  return s ? /* @__PURE__ */ e("foreignObject", { x: t, y: n, width: r, height: o, children: /* @__PURE__ */ e(
    "button",
    {
      style: {
        width: "100%",
        height: "100%",
        background: "transparent",
        border: "none",
        padding: 0,
        cursor: "pointer",
        position: "relative"
      },
      "aria-label": `${i.itemName} ${Pt(i.price, i.currency)} ${f(new Date(i.from))} - ${f(new Date(i.to))} ${i.status}`,
      onClick: () => s(i.id),
      onMouseEnter: () => h(i.id),
      onMouseLeave: () => h(null),
      onFocus: () => h(i.id),
      onBlur: () => h(null),
      children: /* @__PURE__ */ e("svg", { width: "100%", height: "100%", style: { position: "absolute", top: 0, left: 0 }, children: k })
    }
  ) }) : k;
}, ml = ({
  schedules: t,
  onEdit: n,
  height: r = 60,
  className: o,
  showLegend: i = !1,
  groupBySeason: a = !1,
  locale: l,
  dateFormatter: s
}) => {
  const { token: c } = J.useToken(), u = br(), [h, f] = I(null), A = ke(
    (p) => s ? s(p) : p.toLocaleDateString(l),
    [s, l]
  ), { data: x, domain: y, domainStart: k } = Z(() => {
    if (t.length === 0)
      return {
        data: [],
        domain: [0, 1],
        domainStart: 0
      };
    const p = [...t].sort(
      (re, Me) => new Date(re.from).getTime() - new Date(Me.from).getTime()
    ), M = p.map((re) => new Date(re.from).getTime()), D = p.map((re) => new Date(re.to).getTime()), G = Math.min(...M), R = Math.max(...D), K = (R - G || 1) * 0.05, me = G - K, le = R + K;
    return {
      data: p.map((re) => ({
        ...re,
        offset: new Date(re.from).getTime() - me,
        duration: new Date(re.to).getTime() - new Date(re.from).getTime()
      })),
      domain: [0, le - me],
      domainStart: me
    };
  }, [t]), v = k + y[1], E = Z(() => {
    const p = (v - k) / 4;
    return Array.from({ length: 5 }, (M, D) => D * p);
  }, [v, k]), b = Date.now() - k, O = b >= 0 && b <= y[1], B = Z(
    () => ({
      ACTIVE: c.colorSuccess,
      FUTURE: c.colorInfo,
      EXPIRED: c.colorTextDisabled,
      OVERLAP: c.colorError
    }),
    [c]
  ), H = Z(() => {
    if (!a)
      return [];
    const p = /* @__PURE__ */ new Map();
    return x.forEach((M) => {
      const D = new Date(M.from).getFullYear().toString(), G = M.offset, R = M.offset + M.duration, X = p.get(D);
      X ? (X.start = Math.min(X.start, G), X.end = Math.max(X.end, R)) : p.set(D, { start: G, end: R });
    }), Array.from(p.entries()).map(([M, D]) => ({
      season: M,
      start: D.start,
      end: D.end
    }));
  }, [a, x]), C = ke(
    (p) => /* @__PURE__ */ e(
      ii,
      {
        ...p,
        patternId: u,
        colorMap: B,
        onEdit: n,
        highlightColor: c.colorPrimaryHover,
        activeId: h,
        setActiveId: f,
        formatDate: A
      }
    ),
    [u, B, n, h, f, c.colorPrimaryHover, A]
  );
  if (t.length === 0)
    return /* @__PURE__ */ e(Cr, { className: o });
  const S = t.some((p) => p.status === "OVERLAP"), P = ({ active: p, payload: M }) => {
    if (p && M?.length) {
      const D = M[0].payload, G = new Date(D.from).getFullYear().toString();
      return /* @__PURE__ */ d("div", { style: { padding: 8 }, children: [
        a && /* @__PURE__ */ d("div", { style: { fontStyle: "italic" }, children: [
          "Season ",
          G
        ] }),
        /* @__PURE__ */ e("div", { children: /* @__PURE__ */ e("strong", { children: D.itemName }) }),
        /* @__PURE__ */ e("div", { children: /* @__PURE__ */ e(fe, { amount: D.price, currency: D.currency }) }),
        /* @__PURE__ */ e("div", { children: /* @__PURE__ */ d("span", { children: [
          A(new Date(D.from)),
          " - ",
          A(new Date(D.to))
        ] }) }),
        /* @__PURE__ */ e("div", { children: /* @__PURE__ */ e(ut, { status: yn(D.status) }) })
      ] });
    }
    return null;
  };
  return /* @__PURE__ */ d("div", { className: o, style: { width: "100%", height: r }, children: [
    S && /* @__PURE__ */ e(ut, { status: yn("OVERLAP") }),
    /* @__PURE__ */ e(to, { width: "100%", height: "100%", children: /* @__PURE__ */ d(no, { data: x, margin: { top: 0, right: 0, left: 0, bottom: 0 }, barCategoryGap: 0, children: [
      /* @__PURE__ */ e("defs", { children: /* @__PURE__ */ d(
        "pattern",
        {
          id: u,
          patternUnits: "userSpaceOnUse",
          width: 8,
          height: 8,
          patternTransform: "rotate(45)",
          children: [
            /* @__PURE__ */ e("rect", { x: "0", y: "0", width: "8", height: "8", fill: c.colorErrorBg }),
            /* @__PURE__ */ e("line", { x1: "0", y1: "0", x2: "0", y2: "8", stroke: c.colorError, strokeWidth: "2" })
          ]
        }
      ) }),
      /* @__PURE__ */ e(
        ro,
        {
          dataKey: "offset",
          type: "number",
          domain: y,
          ticks: E,
          tickFormatter: (p) => A(new Date(k + p)),
          tick: { fontSize: 10 }
        }
      ),
      /* @__PURE__ */ e(oo, { hide: !0 }),
      /* @__PURE__ */ e(io, { content: P }),
      a && H.map((p) => /* @__PURE__ */ e(
        an,
        {
          x: (p.start + p.end) / 2,
          stroke: "none",
          label: { position: "top", value: p.season, fontSize: 10 }
        },
        p.season
      )),
      O && /* @__PURE__ */ e(
        an,
        {
          x: b,
          stroke: c.colorWarning,
          strokeDasharray: "3 3",
          label: { position: "top", value: "Today", fontSize: 10 }
        }
      ),
      /* @__PURE__ */ e(
        ao,
        {
          dataKey: "duration",
          minPointSize: 2,
          isAnimationActive: !1,
          shape: C
        }
      )
    ] }) }),
    i && /* @__PURE__ */ e(
      "section",
      {
        className: "mt-1 flex flex-wrap gap-2 text-xs",
        "data-testid": "legend",
        "aria-label": "Chart legend",
        children: Object.entries(B).map(
          ([p, M]) => /* @__PURE__ */ d("div", { className: "flex items-center gap-1", children: [
            /* @__PURE__ */ e(
              "span",
              {
                className: "inline-block w-3 h-3 rounded-sm border",
                style: { backgroundColor: M, borderColor: M },
                "data-testid": `legend-swatch-${p}`
              }
            ),
            /* @__PURE__ */ e("span", { children: p })
          ] }, p)
        )
      }
    )
  ] });
};
function yn(t) {
  switch (t) {
    case "ACTIVE":
      return "ISSUED";
    case "FUTURE":
      return "DRAFT";
    case "EXPIRED":
      return "VOID";
    case "OVERLAP":
      return "OVERDUE";
    default:
      return "DRAFT";
  }
}
const qn = (t) => /* @__PURE__ */ e(xr, { destroyOnClose: !0, ...t }), hl = ({
  open: t,
  items: n,
  existing: r,
  onCreate: o,
  onClose: i,
  drawerWidth: a = 500
}) => {
  const { message: l } = Te.useApp(), [s, c] = I(0), [u, h] = I(), [f, A] = I(null), [x, y] = I(0), [k, v] = I("ZAR"), [E, b] = I(!1);
  ie(() => {
    t || (c(0), h(void 0), A(null), y(0), v("ZAR"), b(!1));
  }, [t]);
  const O = n.find((D) => D.id === u), B = f ? f[0].isAfter(f[1]) : !1, C = (() => {
    if (!f || !O) return !1;
    const [D, G] = f;
    return r.filter((R) => R.itemName === O.name).some((R) => {
      const X = te(R.from), K = te(R.to);
      return !X.isAfter(G) && !K.isBefore(D);
    });
  })(), S = !!u, P = !!f && !B && !C, p = async () => {
    if (!(!O || !f)) {
      b(!0);
      try {
        const [D, G] = f, R = {
          itemName: O.name,
          from: D.toISOString(),
          to: G.toISOString(),
          price: x,
          currency: k,
          id: "",
          status: "FUTURE"
        };
        await Promise.resolve(o(R)), i();
      } catch (D) {
        l.error(m("en-US", "createError")), console.error(D);
      } finally {
        b(!1);
      }
    }
  }, M = [
    /* @__PURE__ */ e(ai, { items: n, itemId: u, onChange: h }, "step1"),
    /* @__PURE__ */ e(
      si,
      {
        dates: f,
        onChange: (D) => A(D),
        rangeInvalid: B,
        overlap: C
      },
      "step2"
    ),
    /* @__PURE__ */ e(
      li,
      {
        item: O?.name ?? "",
        dates: f,
        price: x,
        currency: k,
        onPriceChange: y,
        onCurrencyChange: v
      },
      "step3"
    ),
    /* @__PURE__ */ e(
      ci,
      {
        item: O?.name ?? "",
        dates: f,
        price: x,
        currency: k
      },
      "review"
    )
  ];
  return /* @__PURE__ */ d(qn, { open: t, onClose: i, size: a, children: [
    /* @__PURE__ */ e(
      It,
      {
        current: s,
        style: { marginBottom: 24 },
        items: [
          { title: m("en-US", "itemLabel") },
          { title: m("en-US", "dateRangeLabel") },
          { title: m("en-US", "priceLabel") },
          { title: m("en-US", "reviewLabel") }
        ]
      }
    ),
    M[s],
    /* @__PURE__ */ d(Y, { style: { marginTop: 24 }, children: [
      s > 0 && /* @__PURE__ */ e(U, { onClick: () => c(s - 1), children: m("en-US", "backAction") }),
      /* @__PURE__ */ d(Y, { style: { marginLeft: "auto" }, children: [
        s < 3 && /* @__PURE__ */ e(
          U,
          {
            type: "primary",
            onClick: () => c(s + 1),
            disabled: s === 0 ? !S : s === 1 ? !P : !1,
            children: m("en-US", "nextAction")
          }
        ),
        s === 3 && /* @__PURE__ */ e(
          U,
          {
            type: "primary",
            onClick: p,
            "data-testid": "create-btn",
            loading: E,
            children: m("en-US", "createAction")
          }
        ),
        /* @__PURE__ */ e(U, { onClick: i, children: m("en-US", "cancelAction") })
      ] })
    ] })
  ] });
}, ai = ({ items: t, itemId: n, onChange: r }) => /* @__PURE__ */ e(_, { layout: "vertical", children: /* @__PURE__ */ e(_.Item, { label: m("en-US", "itemLabel"), required: !0, children: /* @__PURE__ */ e(
  Je,
  {
    showSearch: !0,
    placeholder: m("en-US", "selectItem"),
    optionFilterProp: "label",
    style: { width: "100%" },
    value: n,
    onChange: r,
    options: t.map((o) => ({ value: o.id, label: o.name }))
  }
) }) }), si = ({ dates: t, onChange: n, rangeInvalid: r, overlap: o }) => {
  const i = te();
  return /* @__PURE__ */ e(_, { layout: "vertical", children: /* @__PURE__ */ e(
    _.Item,
    {
      label: m("en-US", "dateRangeLabel"),
      validateStatus: r || o ? "error" : "",
      help: r ? m("en-US", "startBeforeEnd") : o ? m("en-US", "scheduleOverlap") : void 0,
      children: /* @__PURE__ */ d(Y, { orientation: "vertical", style: { width: "100%" }, size: "middle", children: [
        /* @__PURE__ */ e(Y, { size: "small", children: /* @__PURE__ */ d(U, { type: "link", onClick: () => n([i, i]), children: [
          /* @__PURE__ */ e("span", { role: "img", "aria-label": "calendar", children: "📅" }),
          " ",
          m("en-US", "today")
        ] }) }),
        /* @__PURE__ */ e(jn, { value: t ?? void 0, onChange: n })
      ] })
    }
  ) });
}, li = ({
  item: t,
  dates: n,
  price: r,
  currency: o,
  onPriceChange: i,
  onCurrencyChange: a
}) => /* @__PURE__ */ d(_, { layout: "vertical", children: [
  /* @__PURE__ */ d($.Text, { children: [
    t,
    " — ",
    n ? `${n[0].format("YYYY-MM-DD")} - ${n[1].format("YYYY-MM-DD")}` : ""
  ] }),
  /* @__PURE__ */ e(_.Item, { label: m("en-US", "priceLabel"), children: /* @__PURE__ */ e(
    Dt,
    {
      value: r,
      onChange: (l) => i(l != null ? Number(l) : 0),
      min: 0,
      style: { width: "100%" }
    }
  ) }),
  /* @__PURE__ */ e(_.Item, { label: m("en-US", "currencyLabel"), children: /* @__PURE__ */ e(
    Je,
    {
      value: o,
      onChange: a,
      options: [
        { value: "ZAR", label: "ZAR" },
        { value: "USD", label: "USD" },
        { value: "EUR", label: "EUR" }
      ]
    }
  ) }),
  /* @__PURE__ */ e(fe, { amount: r, currency: o })
] }), ci = ({ item: t, dates: n, price: r, currency: o }) => /* @__PURE__ */ d(Y, { orientation: "vertical", style: { width: "100%" }, size: "middle", children: [
  /* @__PURE__ */ e($.Text, { strong: !0, children: t }),
  /* @__PURE__ */ e($.Text, { children: n ? `${n[0].format("YYYY-MM-DD")} - ${n[1].format("YYYY-MM-DD")}` : "" }),
  /* @__PURE__ */ e(fe, { amount: r, currency: o })
] }), di = "startBeforeEnd", ui = "scheduleOverlap", bn = (t, n, r) => n && t.isAfter(n) ? di : r(t, n) ? ui : null, mi = [
  { label: "ZAR", value: "ZAR" },
  { label: "USD", value: "USD" },
  { label: "EUR", value: "EUR" }
], hi = so.string().length(3, "Invalid currency code").regex(/^[A-Za-z]{3}$/, "Invalid currency code").transform((t) => t.toUpperCase()), gl = ({
  visible: t,
  schedule: n,
  otherSchedules: r,
  onSave: o,
  onCancel: i,
  onDelete: a
}) => {
  const [l] = _.useForm(), [s, c] = I(null);
  ie(() => {
    t && l.setFieldsValue({
      itemName: n.itemName,
      range: [te(n.from), n.to ? te(n.to) : null],
      price: n.price,
      currency: n.currency ?? "ZAR"
    });
  }, [t, n, l]);
  const u = (y, k) => r?.length ? r.some((v) => {
    if (v.id === n.id) return !1;
    const E = te(v.from), b = v.to ? te(v.to) : null, O = !b || y.isBefore(b) || y.isSame(b), B = !k || E.isBefore(k) || E.isSame(k);
    return O && B;
  }) : !1, h = () => {
    const [y, k] = l.getFieldValue("range");
    if (!y || k === void 0) {
      c(null);
      return;
    }
    c(bn(y, k, u));
  }, f = async () => {
    try {
      const y = await l.validateFields(), [k, v] = y.range, E = bn(k, v, u);
      if (E) {
        c(E);
        return;
      }
      const b = hi.safeParse(y.currency);
      if (!b.success) {
        l.setFields([{ name: "currency", errors: [b.error.issues[0].message] }]);
        return;
      }
      o({
        ...n,
        itemName: y.itemName,
        from: k.toISOString(),
        to: v ? v.toISOString() : "",
        price: y.price,
        currency: b.data
      }), l.resetFields(), c(null);
    } catch {
    }
  }, A = () => {
    l.resetFields(), c(null), i();
  }, x = () => {
    a && (a(n.id), l.resetFields(), c(null));
  };
  return /* @__PURE__ */ e(
    et,
    {
      title: m("en-US", "editPriceScheduleTitle"),
      open: t,
      onOk: f,
      onCancel: A,
      okText: m("en-US", "saveAction"),
      cancelText: m("en-US", "cancelAction"),
      footer: /* @__PURE__ */ d(Y, { style: { display: "flex", justifyContent: "space-between", width: "100%" }, children: [
        a ? /* @__PURE__ */ e(
          _r,
          {
            title: m("en-US", "deleteConfirmTitle"),
            description: m("en-US", "deleteScheduleConfirmMessage"),
            onConfirm: x,
            okText: m("en-US", "deleteAction"),
            cancelText: m("en-US", "cancelAction"),
            okButtonProps: { danger: !0 },
            children: /* @__PURE__ */ e(U, { danger: !0, icon: /* @__PURE__ */ e(Fn, {}), "data-testid": "delete-btn", children: m("en-US", "deleteAction") })
          }
        ) : /* @__PURE__ */ e("div", {}),
        /* @__PURE__ */ d(Y, { children: [
          /* @__PURE__ */ e(U, { onClick: A, children: m("en-US", "cancelAction") }),
          /* @__PURE__ */ e(U, { type: "primary", onClick: f, children: m("en-US", "saveAction") })
        ] })
      ] }),
      children: /* @__PURE__ */ d(_, { form: l, layout: "vertical", onFieldsChange: h, children: [
        /* @__PURE__ */ e(
          _.Item,
          {
            name: "itemName",
            label: m("en-US", "itemLabel"),
            rules: [{ required: !0 }],
            children: /* @__PURE__ */ e(V, { "data-testid": "itemName" })
          }
        ),
        /* @__PURE__ */ e(
          _.Item,
          {
            name: "range",
            label: m("en-US", "dateRangeLabel"),
            rules: [{ required: !0 }],
            validateStatus: s ? "error" : void 0,
            help: s ? m("en-US", s) : void 0,
            children: /* @__PURE__ */ e(jn, { "data-testid": "range" })
          }
        ),
        /* @__PURE__ */ e(
          _.Item,
          {
            name: "price",
            label: m("en-US", "priceLabel"),
            rules: [{ required: !0, type: "number", min: 0 }],
            children: /* @__PURE__ */ e(Dt, { "data-testid": "price", style: { width: "100%" } })
          }
        ),
        /* @__PURE__ */ e(
          _.Item,
          {
            name: "currency",
            label: m("en-US", "currencyLabel"),
            rules: [{ required: !0 }],
            children: /* @__PURE__ */ e(Je, { options: mi, "data-testid": "currency" })
          }
        )
      ] })
    }
  );
}, wt = (t, n = 1) => t.map((r, o, i) => ({
  key: r.id,
  title: r.title,
  children: r.children ? wt(r.children, n + 1) : void 0,
  ariaLevel: n,
  ariaPosinset: o + 1,
  ariaSetsize: i.length
})), Le = (t) => t.map((n) => ({
  id: String(n.key),
  title: typeof n.title == "string" ? n.title : "",
  children: n.children ? Le(n.children) : void 0
})), lt = (t) => t.map((n) => ({
  ...n,
  children: n.children ? lt(n.children) : void 0
})), Gn = (t, n, r) => t.map((o) => {
  if (o.key === n)
    return { ...o, title: r };
  if (o.children) {
    const i = Gn(o.children, n, r);
    if (i !== o.children)
      return { ...o, children: i };
  }
  return o;
}), Yn = (t) => !t.children || t.children.length === 0 ? 1 : 1 + Math.max(...t.children.map(Yn)), it = (t) => t.length === 0 ? 0 : Math.max(...t.map(Yn)), fl = (t) => {
  const n = [], r = (o) => {
    o.forEach((i) => {
      n.push({ id: i.id, title: i.title }), i.children && r(i.children);
    });
  };
  return r(t), n;
}, Kn = (t, n) => {
  if (!n) return t;
  const r = n.toLowerCase();
  return t.map((o) => {
    const i = o.children ? Kn(o.children, n) : [];
    return String(o.title).toLowerCase().includes(r) || i.length ? { ...o, children: i } : null;
  }).filter(Boolean);
}, De = (t, n, r = null) => {
  for (let o = 0; o < t.length; o++) {
    const i = t[o];
    if (i.key === n)
      return { parent: t, index: o, parentNode: r };
    const a = i.children;
    if (a) {
      const l = De(a, n, i);
      if (l) return l;
    }
  }
  return null;
}, kt = (t, n, r) => {
  for (let o = 0; o < t.length; o++) {
    const i = t[o];
    if (i.key === n)
      return r?.(i, o, t), i;
    if (i.children) {
      const a = kt(i.children, n, r);
      if (a) return a;
    }
  }
  return null;
}, Ct = (t, n) => {
  for (let r = 0; r < t.length; r++) {
    const o = t[r];
    if (o.key === n)
      return t.splice(r, 1)[0];
    const i = o.children;
    if (i) {
      const a = Ct(i, n);
      if (a) return a;
    }
  }
  return null;
}, Sn = (t, n) => {
  const r = De(t, n);
  if (!r || r.index === 0) return !1;
  const { parent: o, index: i } = r;
  return [o[i - 1], o[i]] = [o[i], o[i - 1]], !0;
}, vn = (t, n) => {
  const r = De(t, n);
  if (!r || r.index === r.parent.length - 1) return !1;
  const { parent: o, index: i } = r;
  return [o[i], o[i + 1]] = [o[i + 1], o[i]], !0;
}, wn = (t, n) => {
  const r = De(t, n);
  if (!r || r.index === 0) return !1;
  const { parent: o, index: i } = r, a = o[i - 1], l = o.splice(i, 1)[0];
  return a.children = a.children || [], a.children.push(l), !0;
}, kn = (t, n) => {
  const r = De(t, n);
  if (!r || !r.parentNode) return !1;
  const { parent: o, index: i, parentNode: a } = r, l = De(t, a.key);
  if (!l) return !1;
  const s = o.splice(i, 1)[0];
  return l.parent.splice(l.index + 1, 0, s), !0;
}, gi = () => typeof globalThis.crypto?.randomUUID == "function" ? globalThis.crypto.randomUUID() : Math.random().toString(36).slice(2), fi = -1e4, pi = -1e4, pl = (t) => {
  const {
    data: n,
    onChange: r,
    className: o,
    maxDepth: i,
    depthErrorMessage: a
  } = t, l = i ?? 4, s = a ?? `Max depth exceeded (limit: ${l})`, { __testOpenMenuForKey: c, __testRenderMenu: u, __testOnFilteredTree: h } = t, [f, A] = I(() => wt(n)), [x, y] = I(""), [k, v] = I(!1), [E, b] = I(null), [O, B] = I(null), [H, C] = I(null), [S, P] = I(""), [p, M] = I(null), { token: D } = J.useToken(), G = Ie(null), R = Ie(null), X = Z(() => {
    const N = [], F = (Q) => {
      Q.forEach((he) => {
        N.push(he.key), he.children && F(he.children);
      });
    };
    return F(f), N;
  }, [f]), K = Z(() => Kn(f, x), [f, x]);
  ie(() => {
    h?.(K);
  }, [h, K]), ie(() => (A(wt(n)), () => {
    G.current && clearTimeout(G.current);
  }), [n]), ie(() => {
    if (!(typeof c > "u")) {
      if (c) {
        M({ x: 0, y: 0, key: c });
        return;
      }
      M(null);
    }
  }, [c]);
  const me = ke(() => {
    v(!0), G.current = setTimeout(() => v(!1), 3e3);
  }, []), le = ke(
    (N) => {
      if (!O) return;
      const F = lt(f);
      if (N(F, O)) {
        if (it(Le(F)) > l) {
          me();
          return;
        }
        A(F), r(Le(F));
      }
    },
    [O, f, l, r, me]
  ), Pe = ke(
    (N) => {
      if (!(!N.ctrlKey || !O))
        switch (N.key) {
          case "ArrowUp":
            le(Sn);
            break;
          case "ArrowDown":
            le(vn);
            break;
          case "ArrowRight":
            le(wn);
            break;
          case "ArrowLeft":
            le(kn);
            break;
        }
    },
    [O, le]
  ), re = ke(
    (N, F) => {
      const Q = Gn(f, N, F.trim() || "Untitled");
      C(null), A(Q), r(Le(Q));
    },
    [f, r]
  ), Me = (N) => {
    const { node: F } = N;
    R.current = F;
  }, tt = () => {
    R.current = null;
  }, nt = (N) => {
    const { node: F } = N, Q = R.current ? it(Le([R.current])) : 1, ae = String(F.pos).split("-").length - 1 + Q;
    b(ae > l ? String(F.key) : null);
  }, gt = (N) => {
    const F = N.node.key, Q = N.dragNode.key, he = N.node.pos.split("-"), ae = N.dropPosition - Number(he.at(-1)), W = lt(f), ve = Ct(W, Q);
    if (!ve) return;
    if (N.dropToGap) {
      const pe = De(W, F);
      if (!pe) return;
      const { parent: Ve, index: we } = pe;
      Ve.splice(ae === -1 ? we : we + 1, 0, ve);
    } else {
      const pe = kt(W, F);
      if (!pe) return;
      pe.children ??= [], pe.children.unshift(ve);
    }
    const ge = Le(W);
    if (it(ge) > l) {
      me(), b(F);
      return;
    }
    b(null), A(W), r(ge);
  }, j = (N) => {
    N.event.preventDefault(), M({
      x: N.event.pageX,
      y: N.event.pageY,
      key: String(N.node.key)
    });
  }, We = ({ key: N }) => {
    if (!p) return;
    const F = p.key, Q = lt(f);
    if (N === "add") {
      const ae = kt(Q, F);
      if (!ae) return;
      const W = {
        key: gi(),
        title: "New node",
        ariaLevel: ae.ariaLevel + 1,
        ariaPosinset: (ae.children?.length ?? 0) + 1,
        ariaSetsize: (ae.children?.length ?? 0) + 1
      };
      ae.children = [...ae.children ?? [], W], ae.children.forEach((ve, ge) => {
        ve.ariaPosinset = ge + 1, ve.ariaSetsize = ae.children ? ae.children.length : 0;
      });
    } else N === "delete" && Ct(Q, F);
    const he = Le(Q);
    if (it(he) > l) {
      me(), b(F), M(null);
      return;
    }
    b(null), A(Q), r(he), M(null);
  };
  ie(() => {
    if (!p)
      return;
    const N = () => M(null);
    return document.addEventListener("mousedown", N), () => {
      document.removeEventListener("mousedown", N);
    };
  }, [p]);
  const ft = Z(() => {
    const N = (F) => F.map((Q) => ({
      ...Q,
      className: Q.key === E ? "text-red-500" : void 0,
      children: Q.children ? N(Q.children) : void 0
    }));
    return N(K);
  }, [K, E]);
  return /* @__PURE__ */ d(be, { children: [
    /* @__PURE__ */ e(
      V,
      {
        placeholder: "Filter…",
        allowClear: !0,
        prefix: /* @__PURE__ */ e(Br, {}),
        style: { marginBottom: 8 },
        value: x,
        onChange: (N) => y(N.target.value)
      }
    ),
    k && /* @__PURE__ */ e(
      $e,
      {
        type: "error",
        message: s,
        closable: !0,
        showIcon: !0,
        style: { marginBottom: 8 }
      }
    ),
    /* @__PURE__ */ e(
      Tr,
      {
        className: o,
        blockNode: !0,
        draggable: !0,
        expandedKeys: X,
        autoExpandParent: !0,
        treeData: ft,
        onClick: (N, F) => {
          B(String(F.key));
        },
        onSelect: (N) => B(String(N[0])),
        onKeyDown: Pe,
        onDragStart: Me,
        onDragEnd: tt,
        onDragOver: nt,
        onDrop: gt,
        onRightClick: j,
        titleRender: (N) => H === N.key ? /* @__PURE__ */ e(
          V,
          {
            size: "small",
            autoFocus: !0,
            value: S,
            onChange: (F) => P(F.target.value),
            onBlur: () => re(String(N.key), S),
            onPressEnter: () => re(String(N.key), S),
            onKeyDown: (F) => F.stopPropagation()
          }
        ) : /* @__PURE__ */ e(
          "span",
          {
            onDoubleClick: () => {
              C(String(N.key)), P(String(N.title));
            },
            className: String(N.className || ""),
            children: String(N.title)
          }
        )
      }
    ),
    /* @__PURE__ */ d("div", { style: { marginTop: 8 }, children: [
      /* @__PURE__ */ e(
        U,
        {
          "aria-label": "Move up",
          size: "small",
          disabled: !O,
          onClick: () => le(Sn),
          children: "↑"
        }
      ),
      /* @__PURE__ */ e(
        U,
        {
          "aria-label": "Move down",
          size: "small",
          disabled: !O,
          onClick: () => le(vn),
          style: { marginLeft: 4 },
          children: "↓"
        }
      ),
      /* @__PURE__ */ e(
        U,
        {
          "aria-label": "Indent",
          size: "small",
          disabled: !O,
          onClick: () => le(wn),
          style: { marginLeft: 4 },
          children: "↪"
        }
      ),
      /* @__PURE__ */ e(
        U,
        {
          "aria-label": "Outdent",
          size: "small",
          disabled: !O,
          onClick: () => le(kn),
          style: { marginLeft: 4 },
          children: "↩"
        }
      )
    ] }),
    p && /* @__PURE__ */ d(
      "div",
      {
        role: "menu",
        "aria-label": "Node actions",
        onMouseDown: (N) => N.stopPropagation(),
        style: {
          position: "absolute",
          left: p.x,
          top: p.y,
          background: D.colorBgElevated,
          border: `1px solid ${D.colorBorder}`,
          borderRadius: D.borderRadiusLG,
          boxShadow: D.boxShadowSecondary,
          display: "flex",
          flexDirection: "column",
          minWidth: 160,
          zIndex: D.zIndexPopupBase
        },
        children: [
          /* @__PURE__ */ e(
            "button",
            {
              type: "button",
              role: "menuitem",
              onClick: () => We({ key: "add" }),
              style: {
                padding: `${D.paddingXS}px ${D.paddingSM}px`,
                textAlign: "left",
                background: "transparent",
                border: "none",
                cursor: "pointer"
              },
              children: "Add child"
            }
          ),
          /* @__PURE__ */ e(
            "button",
            {
              type: "button",
              role: "menuitem",
              onClick: () => We({ key: "delete" }),
              style: {
                padding: `${D.paddingXS}px ${D.paddingSM}px`,
                textAlign: "left",
                background: "transparent",
                border: "none",
                cursor: "pointer"
              },
              children: "Delete"
            }
          )
        ]
      }
    ),
    u && p && /* @__PURE__ */ d(
      "div",
      {
        "data-testid": "classification-tree__test-menu",
        style: {
          position: "absolute",
          left: fi,
          top: pi
        },
        children: [
          /* @__PURE__ */ e(
            "button",
            {
              type: "button",
              onClick: () => We({ key: "add" }),
              children: "Add child"
            }
          ),
          /* @__PURE__ */ e(
            "button",
            {
              type: "button",
              onClick: () => We({ key: "delete" }),
              children: "Delete"
            }
          )
        ]
      }
    )
  ] });
}, yl = ({
  currency: t = "ZAR",
  style: n,
  onChange: r,
  ...o
}) => /* @__PURE__ */ e(
  Dt,
  {
    step: 0.01,
    style: { width: "100%", ...n },
    formatter: (i) => i == null ? "" : `${Pt(i, t, !1)} ${t}`,
    parser: (i) => Number(String(i).replace(/[A-Za-z\s,]+/g, "")),
    onChange: (i) => r?.(typeof i == "number" ? i : null),
    ...o
  }
), bl = ({
  balance: t = null,
  adjustments: n = []
}) => {
  const [r, o] = I(t), [i, a] = I(n ?? []), l = Z(
    () => (i ?? []).filter((c) => c.amount > 0),
    [i]
  ), s = Z(
    () => (i ?? []).filter((c) => c.amount < 0),
    [i]
  );
  return ie(() => {
    if (t !== null || n && n.length > 0) {
      o(t), a(n ?? []);
      return;
    }
    (async () => {
      try {
        const u = await fetch("/api/stripe/balance");
        if (!u.ok)
          throw new Error("Failed to fetch balance");
        const h = await u.json();
        o(h.balance), a(Array.isArray(h.adjustments) ? h.adjustments : []);
      } catch (u) {
        console.error(u);
      }
    })();
  }, [t, n]), /* @__PURE__ */ d(He, { title: "Current Balance", bordered: !1, "data-testid": "balance-card", children: [
    /* @__PURE__ */ e("div", { "data-testid": "current-balance", children: r !== null ? (r / 100).toFixed(2) : "Loading..." }),
    /* @__PURE__ */ d("div", { style: { marginTop: 12 }, children: [
      /* @__PURE__ */ e("div", { children: "Credits" }),
      l.length === 0 ? /* @__PURE__ */ e("div", { children: "None" }) : /* @__PURE__ */ e("div", { role: "list", style: { display: "flex", flexDirection: "column", gap: 6 }, children: l.map((c) => /* @__PURE__ */ d(
        "div",
        {
          role: "listitem",
          "data-testid": "adjustment-item",
          style: {
            display: "flex",
            justifyContent: "space-between",
            padding: "6px 0",
            borderBottom: "1px solid #f0f0f0"
          },
          children: [
            /* @__PURE__ */ e("div", { children: c.description ?? c.type }),
            /* @__PURE__ */ e("span", { children: (c.amount / 100).toFixed(2) })
          ]
        },
        c.id
      )) })
    ] }),
    /* @__PURE__ */ d("div", { style: { marginTop: 12 }, children: [
      /* @__PURE__ */ e("div", { children: "Debits" }),
      s.length === 0 ? /* @__PURE__ */ e("div", { children: "None" }) : /* @__PURE__ */ e("div", { role: "list", style: { display: "flex", flexDirection: "column", gap: 6 }, children: s.map((c) => /* @__PURE__ */ d(
        "div",
        {
          role: "listitem",
          "data-testid": "adjustment-item",
          style: {
            display: "flex",
            justifyContent: "space-between",
            padding: "6px 0",
            borderBottom: "1px solid #f0f0f0"
          },
          children: [
            /* @__PURE__ */ e("div", { children: c.description ?? c.type }),
            /* @__PURE__ */ e("span", { children: (c.amount / 100).toFixed(2) })
          ]
        },
        c.id
      )) })
    ] })
  ] });
}, Sl = ({ invoices: t, groupBySeason: n = !1 }) => {
  const [r, o] = I("ALL"), i = r === "ALL" ? t : t.filter((u) => u.status === r), a = (u) => ({ "data-label": u }), l = Z(() => n ? i.reduce(
    (u, h) => {
      const f = h.period.match(/(\d{4})/), A = f ? f[1] : "Unknown";
      return u[A] || (u[A] = []), u[A].push(h), u;
    },
    {}
  ) : { All: i }, [i, n]), s = [
    {
      title: "Invoice #",
      dataIndex: "id",
      sorter: (u, h) => u.id.localeCompare(h.id),
      onCell: () => a("Invoice #")
    },
    {
      title: "Period",
      dataIndex: "period",
      sorter: (u, h) => u.period.localeCompare(h.period),
      onCell: () => a("Period")
    },
    {
      title: "Amount",
      dataIndex: "amount",
      sorter: (u, h) => u.amount - h.amount,
      render: (u, h) => /* @__PURE__ */ d(Y, { orientation: "vertical", children: [
        /* @__PURE__ */ e(fe, { amount: u }),
        h.paidBy && /* @__PURE__ */ e($.Text, { type: "secondary", children: `Paid by ${h.paidBy}` })
      ] }),
      onCell: () => a("Amount")
    },
    {
      title: "Status",
      dataIndex: "status",
      sorter: (u, h) => u.status.localeCompare(h.status),
      render: (u) => /* @__PURE__ */ e(ut, { status: u }),
      onCell: () => a("Status")
    },
    {
      title: "Download PDF",
      dataIndex: "pdfUrl",
      render: (u, h) => /* @__PURE__ */ e("a", { href: u, "aria-label": `Download invoice ${h.id}`, children: "PDF" }),
      onCell: () => a("Download PDF")
    }
  ], c = Array.from(new Set(t.map((u) => u.status)));
  return /* @__PURE__ */ d("div", { children: [
    /* @__PURE__ */ e(
      Je,
      {
        placeholder: "Status",
        value: r === "ALL" ? void 0 : r,
        allowClear: !0,
        onChange: (u) => o(u ?? "ALL"),
        style: { width: 160, marginBottom: 16 },
        children: c.map((u) => /* @__PURE__ */ e(Je.Option, { value: u, children: u }, u))
      }
    ),
    Object.entries(l).map(([u, h]) => /* @__PURE__ */ d(
      "div",
      {
        "data-testid": `season-${u}`,
        style: { marginBottom: n ? 16 : 0 },
        children: [
          n && /* @__PURE__ */ e($.Title, { level: 5, style: { marginTop: 0 }, children: u }),
          /* @__PURE__ */ e(
            ee,
            {
              rowKey: "id",
              columns: s,
              dataSource: h,
              pagination: !1,
              className: "scl-responsive-table"
            }
          )
        ]
      },
      u
    ))
  ] });
}, yi = "_invoiceModal_djzrq_1", bi = "_fullWidth_djzrq_5", Si = "_summaryCell_djzrq_8", vi = "_notesDivider_djzrq_17", wi = "_notesParagraph_djzrq_21", ye = {
  invoiceModal: yi,
  fullWidth: bi,
  summaryCell: Si,
  notesDivider: vi,
  notesParagraph: wi
}, ki = ({ invoice: t }) => /* @__PURE__ */ d(ee.Summary, { children: [
  /* @__PURE__ */ d(ee.Summary.Row, { children: [
    /* @__PURE__ */ e(ee.Summary.Cell, { index: 0, colSpan: 3, align: "right", children: "Sub-total" }),
    /* @__PURE__ */ e(ee.Summary.Cell, { index: 3, align: "right", className: ye.summaryCell, children: /* @__PURE__ */ e(fe, { amount: t.subTotal, currency: t.currency }) })
  ] }),
  t.discount !== void 0 && /* @__PURE__ */ d(ee.Summary.Row, { children: [
    /* @__PURE__ */ e(ee.Summary.Cell, { index: 0, colSpan: 3, align: "right", children: "Discount" }),
    /* @__PURE__ */ e(ee.Summary.Cell, { index: 3, align: "right", className: ye.summaryCell, children: /* @__PURE__ */ e(fe, { amount: t.discount, currency: t.currency }) })
  ] }),
  t.otherCharges !== void 0 && /* @__PURE__ */ d(ee.Summary.Row, { children: [
    /* @__PURE__ */ e(ee.Summary.Cell, { index: 0, colSpan: 3, align: "right", children: "Other Charges" }),
    /* @__PURE__ */ e(ee.Summary.Cell, { index: 3, align: "right", className: ye.summaryCell, children: /* @__PURE__ */ e(fe, { amount: t.otherCharges, currency: t.currency }) })
  ] }),
  /* @__PURE__ */ d(ee.Summary.Row, { children: [
    /* @__PURE__ */ e(ee.Summary.Cell, { index: 0, colSpan: 3, align: "right", children: "VAT" }),
    /* @__PURE__ */ e(ee.Summary.Cell, { index: 3, align: "right", className: ye.summaryCell, children: /* @__PURE__ */ e(fe, { amount: t.vat, currency: t.currency }) })
  ] }),
  /* @__PURE__ */ d(ee.Summary.Row, { children: [
    /* @__PURE__ */ e(ee.Summary.Cell, { index: 0, colSpan: 3, align: "right", children: /* @__PURE__ */ e($.Text, { strong: !0, children: "Grand Total" }) }),
    /* @__PURE__ */ e(ee.Summary.Cell, { index: 3, align: "right", className: ye.summaryCell, children: /* @__PURE__ */ e(fe, { amount: t.grandTotal, currency: t.currency }) })
  ] })
] }), vl = ({
  visible: t,
  invoice: n,
  onClose: r,
  onDownloadPdf: o,
  onDelete: i
}) => {
  const [a, l] = z.useState(null), s = [
    { title: "Description", dataIndex: "description", key: "description" },
    { title: "Qty", dataIndex: "qty", key: "qty", align: "right" },
    {
      title: "Unit Price",
      dataIndex: "unitPrice",
      key: "unitPrice",
      render: (u) => /* @__PURE__ */ e(fe, { amount: u, currency: n.currency }),
      align: "right"
    },
    {
      title: "Total",
      dataIndex: "total",
      key: "total",
      render: (u) => /* @__PURE__ */ e(fe, { amount: u, currency: n.currency }),
      align: "right"
    },
    {
      title: "Delete",
      key: "delete",
      align: "center",
      render: (u, h) => /* @__PURE__ */ e(
        U,
        {
          icon: /* @__PURE__ */ e(Fn, {}),
          "aria-label": "Delete line",
          onClick: () => l(h.id)
        }
      )
    }
  ], c = () => {
    typeof window < "u" && typeof window.print == "function" && window.print();
  };
  return /* @__PURE__ */ d(be, { children: [
    /* @__PURE__ */ e(
      et,
      {
        title: null,
        open: t,
        onCancel: r,
        footer: null,
        width: 720,
        rootClassName: ye.invoiceModal,
        destroyOnClose: !0,
        children: /* @__PURE__ */ d(Y, { orientation: "vertical", className: ye.fullWidth, size: "middle", children: [
          /* @__PURE__ */ d(Y, { align: "center", wrap: !0, children: [
            /* @__PURE__ */ e(Wn, { size: "small" }),
            /* @__PURE__ */ e($.Text, { strong: !0, children: n.memberName }),
            /* @__PURE__ */ e($.Text, { children: "-" }),
            /* @__PURE__ */ e($.Text, { children: n.invoiceNumber }),
            /* @__PURE__ */ e(ut, { status: n.status })
          ] }),
          /* @__PURE__ */ d(ue, { column: 1, size: "small", children: [
            /* @__PURE__ */ e(ue.Item, { label: "Issuer", children: n.issuerAddress }),
            /* @__PURE__ */ e(ue.Item, { label: "Recipient", children: n.recipientAddress }),
            /* @__PURE__ */ e(ue.Item, { label: "Issue Date", children: te(n.issueDate).format("YYYY-MM-DD") }),
            /* @__PURE__ */ e(ue.Item, { label: "Due Date", children: te(n.dueDate).format("YYYY-MM-DD") })
          ] }),
          /* @__PURE__ */ e(
            ee,
            {
              rowKey: "id",
              dataSource: n.lines,
              columns: s,
              pagination: !1,
              size: "small",
              summary: () => /* @__PURE__ */ e(ki, { invoice: n })
            }
          ),
          n.notes && /* @__PURE__ */ d(be, { children: [
            /* @__PURE__ */ e(Ar, { className: ye.notesDivider }),
            /* @__PURE__ */ e($.Paragraph, { className: ye.notesParagraph, children: n.notes })
          ] }),
          /* @__PURE__ */ d(vt, { justify: "space-between", align: "middle", className: ye.fullWidth, children: [
            /* @__PURE__ */ e(ct, { children: o && /* @__PURE__ */ e(
              U,
              {
                icon: /* @__PURE__ */ e(Fr, {}),
                onClick: () => o(n.id),
                "aria-label": "Download PDF",
                children: "Download PDF"
              }
            ) }),
            /* @__PURE__ */ e(ct, { children: /* @__PURE__ */ d(Y, { children: [
              /* @__PURE__ */ e(U, { icon: /* @__PURE__ */ e($r, {}), onClick: c, "aria-label": "Print", children: "Print" }),
              /* @__PURE__ */ e(U, { type: "primary", onClick: r, "aria-label": "Close invoice preview", children: "Close" })
            ] }) })
          ] })
        ] })
      }
    ),
    /* @__PURE__ */ e(
      et,
      {
        open: a !== null,
        title: "Delete line?",
        onOk: () => {
          a && i?.(a), l(null);
        },
        onCancel: () => l(null),
        okText: "Delete",
        cancelText: "Cancel",
        children: /* @__PURE__ */ e($.Paragraph, { children: "Are you sure you want to remove this line item from the invoice?" })
      }
    )
  ] });
}, wl = ({ data: t = [] }) => {
  const n = Array.isArray(t) ? t : [];
  return /* @__PURE__ */ e(He, { title: "Feature Usage", bordered: !1, children: /* @__PURE__ */ e("div", { role: "list", style: { display: "flex", flexDirection: "column", gap: 8 }, children: (n.length ? n : [{ feature: "N/A", count: 0 }]).map(({ feature: r, count: o }) => /* @__PURE__ */ d(
    "div",
    {
      role: "listitem",
      style: {
        display: "flex",
        justifyContent: "space-between",
        padding: "6px 0",
        borderBottom: "1px solid #f0f0f0"
      },
      children: [
        /* @__PURE__ */ e("div", { children: r }),
        /* @__PURE__ */ e("div", { children: o })
      ]
    },
    r
  )) }) });
}, kl = ({ data: t = [] }) => /* @__PURE__ */ e(He, { title: "System Health", bordered: !1, children: t.length ? t.map(({ name: n, value: r }) => /* @__PURE__ */ d("div", { style: { marginBottom: 8 }, children: [
  /* @__PURE__ */ e("div", { children: n }),
  /* @__PURE__ */ e(Nr, { percent: r, size: "small" })
] }, n)) : /* @__PURE__ */ e("div", { children: "No data" }) }), Ci = new mo(), xi = (t) => lo({
  mutationKey: ["tenantsControllerCreateTenant"],
  mutationFn: (n) => Ci.tenantsControllerCreateTenant(
    n[0],
    n[1]
  ).then(({ data: r }) => r),
  ...t
}), Cl = ({
  open: t,
  onClose: n,
  initialStep: r = 0
}) => {
  const [o, i] = I(r), [a, l] = I({
    name: "",
    email: ""
  }), [s, c] = I(), [u, h] = I([]), f = xi(), A = o === 0 && !a.name || o === 1 && !s, x = async () => {
    try {
      const y = { name: a.name };
      await f.mutateAsync([y]), n();
    } catch {
    }
  };
  return /* @__PURE__ */ d(qn, { open: t, onClose: n, size: 520, children: [
    /* @__PURE__ */ e(
      It,
      {
        current: o,
        items: [{ title: "Tenant details" }, { title: "Plan selection" }, { title: "Options" }],
        style: { marginBottom: 24 }
      }
    ),
    o === 0 && /* @__PURE__ */ d(_, { layout: "vertical", children: [
      /* @__PURE__ */ e(_.Item, { label: "Name", required: !0, children: /* @__PURE__ */ e(
        V,
        {
          value: a.name,
          onChange: (y) => l({ ...a, name: y.target.value })
        }
      ) }),
      /* @__PURE__ */ e(_.Item, { label: "Email", required: !0, children: /* @__PURE__ */ e(
        V,
        {
          value: a.email,
          onChange: (y) => l({ ...a, email: y.target.value })
        }
      ) })
    ] }),
    o === 1 && /* @__PURE__ */ e(_, { layout: "vertical", children: /* @__PURE__ */ e(_.Item, { label: "Plan", required: !0, children: /* @__PURE__ */ d(Xe.Group, { value: s, onChange: (y) => c(y.target.value), children: [
      /* @__PURE__ */ e(Xe, { value: "basic", children: "Basic" }),
      /* @__PURE__ */ e(Xe, { value: "pro", children: "Pro" })
    ] }) }) }),
    o === 2 && /* @__PURE__ */ e(_, { layout: "vertical", children: /* @__PURE__ */ e(_.Item, { label: "Modules", children: /* @__PURE__ */ d(Oe.Group, { value: u, onChange: (y) => h(y), children: [
      /* @__PURE__ */ e(Oe, { value: "sms", children: "SMS" }),
      /* @__PURE__ */ e(Oe, { value: "reports", children: "Reports" })
    ] }) }) }),
    /* @__PURE__ */ d("div", { style: { marginTop: 24 }, children: [
      o > 0 && /* @__PURE__ */ e(U, { onClick: () => i(o - 1), style: { marginRight: 8 }, children: "Back" }),
      o < 2 && /* @__PURE__ */ e(U, { type: "primary", onClick: () => i(o + 1), disabled: !!A, children: "Next" }),
      o === 2 && /* @__PURE__ */ e(U, { type: "primary", onClick: x, style: { marginRight: 8 }, children: "Finish" }),
      /* @__PURE__ */ e(U, { onClick: n, children: "Cancel" })
    ] })
  ] });
}, Qn = Sr({
  appName: "MyWebApp"
}), xl = () => vr(Qn), _l = ({
  children: t,
  appName: n
}) => {
  const [r] = I(() => new co());
  return /* @__PURE__ */ e(Qn.Provider, { value: { appName: n }, children: /* @__PURE__ */ e(uo, { client: r, children: t }) });
}, Tl = ({
  open: t,
  sizes: n,
  onAdd: r,
  onCancel: o
}) => {
  const [i, a] = I();
  return /* @__PURE__ */ e(
    et,
    {
      title: "Choose Size",
      open: t,
      onOk: () => {
        i && r(i);
      },
      onCancel: o,
      okButtonProps: { disabled: !i },
      children: /* @__PURE__ */ e(Xe.Group, { onChange: (s) => a(s.target.value), value: i, children: n.map((s) => /* @__PURE__ */ e(Xe, { value: s, "aria-label": `size-${s}`, children: s }, s)) })
    }
  );
}, xt = "id", { Dragger: _i } = Lr, Ti = (t, n) => {
  const r = t.trim().split(/\r?\n/);
  if (!r.length) return [];
  const o = n ?? (r.length > 0 ? r.shift()?.split(",") ?? [] : []);
  return r.map((i, a) => {
    const l = i.split(","), s = o.reduce((c, u, h) => (c[u] = l[h] ?? "", c), {});
    return { [xt]: a, ...s };
  });
}, Al = ({ onUpload: t, headers: n }) => {
  const [r, o] = I([]), i = async (c) => "text" in c && typeof c.text == "function" ? c.text() : new Promise((u, h) => {
    const f = new FileReader();
    f.onload = () => u(f.result), f.onerror = () => h(f.error), f.readAsText(c);
  }), a = async (c) => {
    const u = await i(c), h = Ti(u, n);
    return o(h), t(h, c), !1;
  }, s = (n ?? (r[0] ? Object.keys(r[0]).filter((c) => c !== xt) : [])).map((c) => ({
    title: c,
    dataIndex: c,
    key: c
  }));
  return /* @__PURE__ */ d("div", { children: [
    /* @__PURE__ */ d(
      _i,
      {
        beforeUpload: a,
        showUploadList: !1,
        style: { marginBottom: 16 },
        "data-testid": "dropzone",
        children: [
          /* @__PURE__ */ e("p", { className: "ant-upload-drag-icon", children: /* @__PURE__ */ e(Or, {}) }),
          /* @__PURE__ */ e("p", { className: "ant-upload-text", children: "Click or drag CSV file to this area to upload" })
        ]
      }
    ),
    r.length > 0 && /* @__PURE__ */ e(ee, { dataSource: r, columns: s, pagination: !1, rowKey: xt })
  ] });
}, Ai = ({ onSubmit: t, submitting: n }) => {
  const [r] = _.useForm();
  return /* @__PURE__ */ d(_, { form: r, layout: "vertical", onFinish: t, children: [
    /* @__PURE__ */ e(_.Item, { label: "First name", name: "firstName", rules: [{ required: !0 }], children: /* @__PURE__ */ e(V, {}) }),
    /* @__PURE__ */ e(_.Item, { label: "Last name", name: "lastName", rules: [{ required: !0 }], children: /* @__PURE__ */ e(V, {}) }),
    /* @__PURE__ */ e(_.Item, { label: "Email", name: "email", rules: [{ required: !0, type: "email" }], children: /* @__PURE__ */ e(V, { type: "email" }) }),
    /* @__PURE__ */ e(_.Item, { label: "Phone", name: "phone", children: /* @__PURE__ */ e(V, {}) }),
    /* @__PURE__ */ e(_.Item, { label: "Date of birth", name: "dateOfBirth", children: /* @__PURE__ */ e(Bn, { style: { width: "100%" } }) }),
    /* @__PURE__ */ e(_.Item, { label: "Club ID", name: "clubId", rules: [{ required: !0 }], children: /* @__PURE__ */ e(V, { type: "number" }) }),
    /* @__PURE__ */ e(_.Item, { children: /* @__PURE__ */ e(U, { type: "primary", htmlType: "submit", loading: n, children: "Submit" }) })
  ] });
}, Nl = () => {
  const { message: t } = Te.useApp(), [n, r] = I(!1);
  return /* @__PURE__ */ e(Ai, { onSubmit: async (i) => {
    r(!0);
    try {
      const a = await globalThis.fetch("/api/members/signup", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ ...i, clubId: Number(i.clubId) })
      });
      if (!a.ok)
        throw new Error(a.statusText || "Signup failed");
      t.success("Signup successful");
    } catch (a) {
      const l = a;
      t.error(l.message || "Signup failed");
    } finally {
      r(!1);
    }
  }, submitting: n });
}, Ll = ({
  label: t,
  error: n,
  id: r,
  className: o = "",
  ...i
}) => {
  const a = r ?? i.name ?? t;
  return /* @__PURE__ */ d("div", { className: "flex flex-col", children: [
    /* @__PURE__ */ e("label", { htmlFor: a, className: "mb-1 text-sm font-medium", children: t }),
    /* @__PURE__ */ e(
      "input",
      {
        id: a,
        className: `border rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent ${n ? "border-red-500" : "border-gray-300"} ${o}`,
        ...i
      }
    ),
    n && /* @__PURE__ */ e("p", { className: "mt-1 text-xs text-red-500", children: n })
  ] });
}, Il = ({
  children: t,
  loading: n,
  block: r,
  className: o = "",
  disabled: i,
  ...a
}) => /* @__PURE__ */ e(
  "button",
  {
    className: `bg-primary text-white px-4 py-2 rounded-md hover:bg-primary/90 focus:outline-none focus:ring-2 focus:ring-primary disabled:opacity-50 ${r ? "w-full" : ""} ${o}`,
    disabled: i || n,
    ...a,
    children: n ? "Loading..." : t
  }
);
function Dl({
  size: t = "middle",
  showTooltip: n = !0,
  className: r
}) {
  const { mode: o, toggleTheme: i } = Et(), a = o === "dark", l = /* @__PURE__ */ e(
    U,
    {
      type: "text",
      size: t,
      icon: a ? /* @__PURE__ */ e(zr, {}) : /* @__PURE__ */ e(Hr, {}),
      onClick: i,
      className: r,
      "aria-label": a ? "Switch to light mode" : "Switch to dark mode",
      style: {
        color: "inherit"
      }
    }
  );
  return n ? /* @__PURE__ */ e(Mn, { title: a ? "Light mode" : "Dark mode", children: l }) : l;
}
function at(t) {
  window.location.assign(t);
}
const El = [
  { kind: "oauth", id: "google", label: "Continue with Google" },
  { kind: "enterprise-saml", id: "microsoft", label: "Continue with Microsoft" }
], Xn = {
  google: "/api/auth/google",
  facebook: "/api/auth/facebook"
}, Ni = "_loginContainer_myvs7_4", Li = "_embeddedContainer_myvs7_31", Ii = "_loginCard_myvs7_36", Di = "_subtitle_myvs7_42", Ei = "_formLabel_myvs7_43", Pi = "_rememberMe_myvs7_44", Mi = "_signupText_myvs7_45", Ui = "_dividerWrapper_myvs7_46", Ri = "_formInput_myvs7_50", Bi = "_dividerLine_myvs7_60", Fi = "_ssoButton_myvs7_64", $i = "_ssoButtonFacebook_myvs7_75 _ssoButton_myvs7_64", Oi = "_darkModal_myvs7_87", zi = "_title_myvs7_107", Hi = "_ssoButtonGoogle_myvs7_136 _ssoButton_myvs7_64", Wi = "_signupLink_myvs7_151", Vi = "_forgotLink_myvs7_152", ji = "_mfaCard_myvs7_156", qi = "_heroSection_myvs7_161", Gi = "_heroContent_myvs7_180", Yi = "_heroTitle_myvs7_188", Ki = "_heroSubtitle_myvs7_197", Qi = "_heroFeatures_myvs7_204", Xi = "_heroFeature_myvs7_204", Zi = "_heroFeatureIcon_myvs7_218", Ji = "_floatingShapes_myvs7_230", ea = "_shape_myvs7_238", ta = "_float_myvs7_230", na = "_shape1_myvs7_249", ra = "_shape2_myvs7_257", oa = "_shape3_myvs7_265", ia = "_loginContent_myvs7_290", aa = "_embeddedContent_myvs7_301", sa = "_background_myvs7_315", la = "_gradientOverlay_myvs7_321", ca = "_slideUp_myvs7_1", da = "_logoContainer_myvs7_374", ua = "_errorAlert_myvs7_397", ma = "_ssoButtonsContainer_myvs7_403", ha = "_ssoButtonMicrosoft_myvs7_443 _ssoButton_myvs7_64", ga = "_passkeyContainer_myvs7_460", fa = "_passkeyButton_myvs7_467", pa = "_passkeyHelper_myvs7_472", ya = "_formGroup_myvs7_494", ba = "_optionsRow_myvs7_519", Sa = "_rememberDevice_myvs7_531", va = "_submitButton_myvs7_549", wa = "_forgotPasswordLink_myvs7_602", ka = "_mfaToggle_myvs7_607", Ca = "_mfaInputsRow_myvs7_618", xa = "_fullWidth_myvs7_642", _a = "_patternDots_myvs7_647", Ta = "_patternGrid_myvs7_648", Aa = "_patternStripes_myvs7_649", Na = "_patternConfetti_myvs7_650", T = {
  loginContainer: Ni,
  embeddedContainer: Li,
  loginCard: Ii,
  subtitle: Di,
  formLabel: Ei,
  rememberMe: Pi,
  signupText: Mi,
  dividerWrapper: Ui,
  formInput: Ri,
  dividerLine: Bi,
  ssoButton: Fi,
  ssoButtonFacebook: $i,
  darkModal: Oi,
  title: zi,
  ssoButtonGoogle: Hi,
  signupLink: Wi,
  forgotLink: Vi,
  mfaCard: ji,
  heroSection: qi,
  heroContent: Gi,
  heroTitle: Yi,
  heroSubtitle: Ki,
  heroFeatures: Qi,
  heroFeature: Xi,
  heroFeatureIcon: Zi,
  floatingShapes: Ji,
  shape: ea,
  float: ta,
  shape1: na,
  shape2: ra,
  shape3: oa,
  loginContent: ia,
  embeddedContent: aa,
  background: sa,
  gradientOverlay: la,
  slideUp: ca,
  logoContainer: da,
  errorAlert: ua,
  ssoButtonsContainer: ma,
  ssoButtonMicrosoft: ha,
  passkeyContainer: ga,
  passkeyButton: fa,
  passkeyHelper: pa,
  formGroup: ya,
  optionsRow: ba,
  rememberDevice: Sa,
  submitButton: va,
  forgotPasswordLink: wa,
  mfaToggle: ka,
  mfaInputsRow: Ca,
  fullWidth: xa,
  patternDots: _a,
  patternGrid: Ta,
  patternStripes: Aa,
  patternConfetti: Na
}, { Content: La } = de, { Title: Ia, Text: Ne } = $, Mt = "dwAuthSync", Da = "__sclExternalAuthSyncPending", mt = "__DW_SOCIAL_AUTH_REMEMBER__", Cn = 22, Ea = 9e4, Zn = 8, _t = /^[^\s@]+@[^\s@]+\.[^\s@]+$/, Pa = (t) => t.toUpperCase().replace(/[^A-Z0-9]/g, "").slice(0, Zn), xn = (t) => {
  const n = t, r = typeof n?.userId == "string" ? n.userId : typeof n?.user?.userId == "string" ? n.user.userId : typeof n?.user?.id == "string" ? n.user.id : "", o = typeof n?.challengeId == "string" ? n.challengeId : "";
  return !r || !o ? null : { userId: r, challengeId: o };
}, Ma = () => {
  if (typeof navigator > "u")
    return "unknown browser";
  const t = navigator.platform || "unknown platform", n = navigator.userAgent || "unknown browser";
  return `${t} - ${n}`.slice(0, 240);
};
function ze(t, n, r, o = !1, i = []) {
  try {
    const a = n.trim();
    if (!a || a.startsWith("//"))
      return r;
    const l = new URL(a, t);
    if (!(l.protocol === "http:" || l.protocol === "https:"))
      return r;
    const c = i.map((h) => {
      try {
        return new URL(h).origin;
      } catch {
        return null;
      }
    }).filter((h) => h !== null), u = o && c.includes(l.origin);
    return l.origin !== t && !u ? r : l.toString();
  } catch {
    return r;
  }
}
function Ze(t) {
  return !t || t === "/" ? "/" : t.endsWith("/") ? t.slice(0, -1) : t;
}
function Tt(t, n = []) {
  const r = Ze(t), o = n.map(Ze);
  return r === "/login" || r === "/register" || r === "/signup" || r === "/forgot-password" || r === "/reset-password" || r.startsWith("/reset-password/") || o.includes(r);
}
function At(t, n, r, o, i = !1, a = [], l = [], s = 0) {
  if (s > 3)
    return ze(
      t,
      o,
      `${t}/`,
      i,
      a
    );
  const c = ze(
    t,
    o,
    `${t}/`,
    i,
    a
  ), u = ze(
    t,
    r,
    c,
    i,
    a
  );
  try {
    const h = new URL(u, t);
    if (h.origin !== t) {
      const x = Ze(h.pathname);
      if (Tt(x, l)) {
        const y = h.searchParams.get("returnTo");
        return y ? At(
          t,
          n,
          new URL(y, h.origin).toString(),
          c,
          i,
          a,
          l,
          s + 1
        ) : c;
      }
      return u;
    }
    const f = Ze(h.pathname), A = Ze(n);
    if (f === A || Tt(f, l)) {
      const x = h.searchParams.get("returnTo");
      return x ? At(
        t,
        n,
        x,
        c,
        i,
        a,
        l,
        s + 1
      ) : c;
    }
    return u;
  } catch {
    return c;
  }
}
function Ua(t, n, r, o = !1, i = []) {
  try {
    const a = ze(
      t,
      r,
      `${t}/`,
      o,
      i
    ), s = new URLSearchParams(n).get("returnTo");
    return s ? ze(
      t,
      s,
      a,
      o,
      i
    ) : a;
  } catch {
    return `${t}/`;
  }
}
function _n() {
  try {
    const t = new Uint8Array(Cn);
    window.crypto.getRandomValues(t);
    const n = t.slice(0, 6).reduce((o, i) => `${o}${i.toString(16).padStart(2, "0")}`, ""), r = t.slice(6).reduce((o, i) => `${o}${i.toString(16).padStart(2, "0")}`, "").slice(0, Cn);
    return `cb-${Date.now().toString(36)}-${n}-${r}`;
  } catch {
    return `cb-${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}`;
  }
}
function Nt(t) {
  try {
    const n = typeof window < "u" ? window.location.origin : "http://localhost", r = new URL(t, n);
    return r.searchParams.set(Mt, "1"), r.toString();
  } catch {
    return t;
  }
}
function Tn(t) {
  try {
    return new URLSearchParams(t).get(Mt) === "1" ? !0 : typeof window < "u" && typeof window.history.state == "object" && window.history.state !== null && window.history.state[Da] === !0;
  } catch {
    return !1;
  }
}
function Ra(t, n, r, o, i = !1, a = [], l = []) {
  const s = Ua(
    t,
    r,
    o,
    i,
    a
  ), c = Tt(n, l) ? n : "/login", u = new URL(c, t);
  return u.searchParams.set("returnTo", s), u.searchParams.set(Mt, "1"), u.toString();
}
function Ba(t, n = "") {
  const r = typeof process < "u" ? process.env?.[t] : void 0, o = globalThis.importMetaEnv?.[t];
  return r ?? o ?? n;
}
function Fa(t, n, r) {
  if (!r) return t;
  try {
    const o = new URL(t, n);
    return o.origin !== n ? Nt(o.toString()) : o.toString();
  } catch {
    return t;
  }
}
function $a(t, n) {
  try {
    const r = new URLSearchParams(n);
    r.delete("provider"), r.delete("error"), r.delete("error_description");
    const o = r.toString();
    return o ? `${t}?${o}` : t;
  } catch {
    return t;
  }
}
function An(t) {
  if (typeof window > "u") return;
  const n = window.history.state ?? null;
  window.history.replaceState(n, document.title, t);
}
function Nn(t) {
  try {
    if (typeof window > "u") return;
    window.sessionStorage.setItem(mt, t ? "1" : "0");
  } catch {
  }
}
function Oa() {
  try {
    if (typeof window > "u") return null;
    const t = window.sessionStorage.getItem(mt);
    return t !== "0" && t !== "1" ? null : (window.sessionStorage.removeItem(mt), t === "1");
  } catch {
    return null;
  }
}
function za(t) {
  const n = t.get("remember");
  return n === "1" ? !0 : n === "0" ? !1 : Oa() ?? !1;
}
function Ln() {
  try {
    if (typeof window > "u") return;
    window.sessionStorage.removeItem(mt);
  } catch {
  }
}
const Ha = ({ style: t }) => /* @__PURE__ */ d(
  "svg",
  {
    viewBox: "0 0 24 24",
    width: "20",
    height: "20",
    focusable: "false",
    "aria-hidden": "true",
    style: { display: "inline-block", verticalAlign: "middle", ...t },
    children: [
      /* @__PURE__ */ e(
        "path",
        {
          fill: "#4285F4",
          d: "M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
        }
      ),
      /* @__PURE__ */ e(
        "path",
        {
          fill: "#34A853",
          d: "M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
        }
      ),
      /* @__PURE__ */ e(
        "path",
        {
          fill: "#FBBC05",
          d: "M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
        }
      ),
      /* @__PURE__ */ e(
        "path",
        {
          fill: "#EA4335",
          d: "M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
        }
      )
    ]
  }
), Wa = {
  google: "ssoButtonGoogle",
  facebook: "ssoButtonFacebook",
  microsoft: "ssoButtonMicrosoft"
}, Jn = {
  kind: "oauth",
  id: "google",
  label: "Continue with Google",
  icon: /* @__PURE__ */ e(Ha, {})
}, er = {
  kind: "oauth",
  id: "facebook",
  label: "Continue with Facebook",
  icon: /* @__PURE__ */ e(Vr, { style: { fontSize: 20 } })
}, Va = {
  kind: "enterprise-saml",
  id: "microsoft",
  label: "Continue with Microsoft",
  icon: /* @__PURE__ */ e(jr, { style: { fontSize: 20 } })
}, ja = [
  Jn,
  er
], qa = {
  google: Jn,
  facebook: er
}, tr = {
  microsoft: Va
};
function Ga(t) {
  return typeof t == "string" && Object.prototype.hasOwnProperty.call(Xn, t);
}
function Ya(t) {
  return typeof t == "string" && Object.prototype.hasOwnProperty.call(tr, t);
}
function Ka(t) {
  const n = /* @__PURE__ */ new Set(), r = [];
  for (const o of t) {
    if (o.kind === "oauth") {
      if (!Ga(o.id) || n.has(`${o.kind}:${o.id}`)) continue;
      const i = qa[o.id], a = o.label.trim() || i.label;
      r.push({
        ...i,
        ...o,
        id: o.id,
        label: a,
        icon: o.icon === void 0 ? i.icon : o.icon
      }), n.add(`${o.kind}:${o.id}`);
      continue;
    }
    if (o.kind === "enterprise-saml") {
      if (!Ya(o.id) || n.has(`${o.kind}:${o.id}`))
        continue;
      const i = tr[o.id], a = o.label.trim() || i.label;
      r.push({
        ...i,
        ...o,
        id: o.id,
        label: a,
        icon: o.icon === void 0 ? i.icon : o.icon
      }), n.add(`${o.kind}:${o.id}`);
    }
  }
  return r;
}
function Qa(t) {
  const n = t.trim().toLowerCase();
  if (!_t.test(n))
    return null;
  const r = n.split("@")[1]?.trim();
  return r && !r.includes("@") ? r : null;
}
function st(t) {
  return t === 404 ? "Microsoft SSO is not configured for this email domain. Use email sign-in or contact your administrator." : t === 429 ? "Too many Microsoft SSO attempts. Please wait a moment and try again." : t === 400 ? "Enter your work email address before continuing with Microsoft." : "Microsoft SSO is temporarily unavailable. Use email sign-in or try again shortly.";
}
const Pl = ({
  appName: t,
  layoutVariant: n = "full",
  themeMode: r,
  asModal: o = !1,
  backgroundClassName: i,
  backgroundImageUrl: a,
  overlay: l,
  onCloseModal: s,
  defaultEmail: c,
  defaultRemember: u,
  placeholderEmail: h,
  placeholderPassword: f,
  logoLightSrc: A,
  logoDarkSrc: x,
  signupPath: y,
  forgotPasswordPath: k,
  idpBaseUrl: v,
  socialAuthBaseUrl: E,
  heroTitle: b,
  heroSubtitle: O,
  heroFeatures: B,
  redirectTo: H = "/",
  allowExternalReturnTo: C = !1,
  allowedExternalReturnToOrigins: S = [],
  publicAuthRoutePaths: P = [],
  authenticatedState: p,
  passkeyAuth: M,
  providers: D = ja
}) => {
  const G = ht(), R = Er(), X = St((g) => g.isAuthenticated), K = St((g) => g.token), me = St((g) => g.login), le = p?.isAuthenticated ?? X, Pe = p?.accessToken ?? K, re = Z(() => le ? dn() === "cookie" ? !0 : Pe ? ho(Pe) > Date.now() + Ea : !1 : !1, [Pe, le]), Me = Z(() => {
    const g = typeof t == "string" ? t.trim() : "";
    if (g && g.toLowerCase() !== "undefined" && g.toLowerCase() !== "null")
      return g;
    const w = typeof document < "u" ? document.title : "", L = typeof w == "string" ? w.trim() : "";
    return L && L.toLowerCase() !== "undefined" && L.toLowerCase() !== "null" ? L : "DigiWedge";
  }, [t]), tt = Z(
    () => xo(go()),
    []
  ), nt = tt !== void 0, { mode: gt } = Et(), { token: j } = J.useToken(), ft = (r ?? (gt === "dark" ? "dark" : "light")) === "dark", { login: N, loading: F, error: Q } = $n(), { verifyLoginMfa: he, loading: ae } = fo(), [W, ve] = I(() => ({
    email: c ?? "",
    password: "",
    remember: !!u
  })), [ge, pe] = I({}), [Ve, we] = I(!1), [pt, Ue] = I(""), [Ut, Ce] = I(""), [Re, xe] = I(""), [nr, Rt] = I(!1), [Bt, se] = I(null), [Ft, rt] = I(!1), [$t, Ot] = I(!1), [zt, Ht] = I(null), [rr, Wt] = I(null), [Vt, je] = I(null), yt = Ie(null), { message: jt } = Te.useApp(), qt = Z(
    () => ({
      "--login-primary": j.colorPrimary,
      "--login-primary-strong": j.colorPrimaryActive || j.colorPrimary,
      "--login-primary-muted": j.colorPrimaryBg || j.colorPrimary,
      "--login-bg": j.colorBgLayout,
      "--login-surface": j.colorBgContainer,
      "--login-surface-elevated": j.colorBgElevated,
      "--login-text": j.colorText,
      "--login-text-muted": j.colorTextSecondary,
      "--login-border": j.colorBorder,
      "--login-border-strong": j.colorBorderSecondary || j.colorBorder,
      "--login-shadow": j.boxShadowSecondary,
      "--login-shadow-soft": j.boxShadowTertiary || j.boxShadowSecondary,
      "--login-radius-lg": `${j.borderRadiusLG}px`,
      "--login-radius-md": `${j.borderRadius}px`,
      "--login-radius-sm": `${j.borderRadiusSM}px`,
      "--login-hero-text": j.colorTextLightSolid || j.colorText,
      "--login-hero-subtext": j.colorTextLightSolid || j.colorTextSecondary,
      "--login-hero-accent": j.colorPrimary
    }),
    [j]
  ), Gt = (g) => (w) => ve((L) => ({
    ...L,
    [g]: w.target.value
  })), or = (g) => ve((w) => ({
    ...w,
    remember: g.target.checked
  })), ne = z.useCallback(
    (g, w, L) => {
      Promise.resolve().then(() => {
        const q = L ? /* @__PURE__ */ d("span", { children: [
          /* @__PURE__ */ e("span", { children: w }),
          /* @__PURE__ */ e("div", { style: { fontSize: 12, opacity: 0.85 }, children: L })
        ] }) : w;
        jt.open({ type: g, content: q });
      });
    },
    [jt]
  ), ir = (g) => !!g && typeof g == "object" && "accessToken" in g && typeof g.accessToken == "string" && g.accessToken.length > 0, Yt = z.useCallback(
    (g, w) => {
      const L = po(), q = dn(), ce = w?.sharedSession ?? (q === "cookie" || W.remember || !ir(g));
      return { type: "login", at: Date.now(), sourceId: L, sharedSession: ce };
    },
    [W.remember]
  ), qe = z.useCallback(
    (g, w) => {
      yo(Yt(g, w));
    },
    [Yt]
  ), ar = async (g) => {
    g.preventDefault();
    const w = {};
    if (W.email ? _t.test(W.email) || (w.email = m("en-US", "loginInvalidEmail")) : w.email = m("en-US", "loginEmailRequired"), W.password || (w.password = m("en-US", "loginPasswordRequired")), pe(w), !Object.keys(w).length)
      try {
        const L = await N(W), q = xn(L);
        if (q) {
          Ce(q.userId), xe(q.challengeId), Ue(""), rt(!1), se(null), ne("info", "Verification code sent. Check your phone."), we(!0);
          return;
        }
        if (L?.mfaRequired) {
          Ce(""), xe(""), Ue(""), se("Verification could not start. Please sign in again to request a new code."), we(!0);
          return;
        }
        Ce(""), xe(""), ne("success", m("en-US", "loginSuccess")), qe(L), Ge(L);
      } catch (L) {
        const q = L?.message || "";
        /401|invalid/i.test(q) ? ne("error", "Email or password is incorrect.") : /423|lock/i.test(q) ? ne(
          "error",
          "Your account is temporarily locked. Try again later or reset your password."
        ) : /429|rate|too many/i.test(q) ? ne("error", "Too many attempts. Please wait a moment and try again.") : ne("error", m("en-US", "loginError"));
      }
  }, sr = Z(() => _t.test(W.email), [W.email]), lr = Z(() => W.password.length > 0, [W.password]), cr = sr && lr, Kt = v === null ? "" : v ?? Ba("VITE_IDP_BASE_URL", ""), Qt = Kt.replace(/\/$/, ""), bt = (E ?? Kt).replace(/\/$/, ""), Xt = Z(() => {
    try {
      const w = new URLSearchParams(R.search).get("returnTo");
      if (w) {
        const L = ze(
          window.location.origin,
          w,
          "",
          C,
          S
        );
        if (L) return L;
      }
    } catch {
    }
    return null;
  }, [C, S, R.search]) ?? H, Be = Z(
    () => At(
      window.location.origin,
      R.pathname,
      Xt,
      H,
      C,
      S,
      P
    ),
    [
      C,
      S,
      Xt,
      R.pathname,
      P,
      H
    ]
  ), Zt = Z(() => Ra(
    window.location.origin,
    R.pathname,
    R.search,
    H,
    C,
    S,
    P
  ), [
    C,
    S,
    R.pathname,
    R.search,
    P,
    H
  ]), dr = y ?? "/signup", Jt = k || v === null ? null : Qt ? `${Qt}/forgot-password` : "/forgot-password", ur = M?.label ?? "Sign in with Passkey", en = M?.helperText, mr = M?.isAvailable ?? !0, tn = Z(
    () => Ka(D),
    [D]
  ), nn = tn.length > 0, Ge = z.useCallback(
    (g) => {
      const w = C && Tn(R.search);
      try {
        const L = new URL(Be, window.location.origin), q = w && L.origin !== window.location.origin ? Nt(L.toString()) : L.toString();
        L.origin === window.location.origin ? G(L.pathname + L.search + L.hash, { replace: !0 }) : at(q);
      } catch {
        const L = w ? Nt(Be) : Be;
        G(L, { replace: !0 });
      }
    },
    [C, Be, R.search, G]
  );
  ie(() => {
    try {
      const g = typeof window < "u" ? window.location.hash : "";
      if (!g || !g.includes("accessToken=")) return;
      const w = bo(), L = So(window.location.search);
      if (!w || L !== w) {
        Ln();
        return;
      }
      const q = new URLSearchParams(g.replace(/^#/, "")), ce = q.get("accessToken");
      if (!ce) return;
      const Ae = q.get("refreshToken") ?? void 0, _e = q.get("jti") ?? void 0, Ye = za(q), Ke = { accessToken: ce, refreshToken: Ae, jti: _e };
      vo(), me(ce, Ae, _e, Ye), qe(Ke, { sharedSession: Ye }), An(window.location.pathname + window.location.search), Ge(Ke);
    } catch {
    }
  }, [qe, Ge, me]), ie(() => {
    if (!re) return;
    const g = Fa(
      Be,
      window.location.origin,
      C && Tn(R.search)
    );
    try {
      const w = new URL(g, window.location.origin);
      if (w.origin === window.location.origin) {
        G(w.pathname + w.search + w.hash, { replace: !0 });
        return;
      }
      at(w.toString());
    } catch {
      G(g, { replace: !0 });
    }
  }, [
    C,
    Be,
    R.search,
    G,
    re
  ]);
  const hr = async () => {
    if (M) {
      Ht(null);
      try {
        Ot(!0);
        const g = await M.onAuthenticate({
          email: W.email.trim() || void 0,
          remember: W.remember
        }), w = xn(g);
        if (w) {
          Ce(w.userId), xe(w.challengeId), Ue(""), rt(!1), se(null), ne("info", "Verification code sent. Check your phone."), we(!0);
          return;
        }
        if (g?.mfaRequired) {
          Ce(""), xe(""), Ue(""), se("Verification could not start. Please sign in again to request a new code."), we(!0);
          return;
        }
        Ce(""), xe(""), ne("success", m("en-US", "loginSuccess")), qe(g), Ge(g);
      } catch (g) {
        if (un(g)) {
          const { message: w } = cn(
            g,
            "Passkey sign-in failed"
          );
          Ht(w), ne("error", w);
        } else g instanceof Error ? g.name === "NotAllowedError" ? ne("info", "Passkey request was cancelled.") : g.name === "NotSupportedError" ? ne("error", "Passkeys are not supported on this device.") : ne("error", g.message || "Passkey sign-in failed") : ne("error", "Passkey sign-in failed");
      } finally {
        Ot(!1);
      }
    }
  }, gr = (g) => {
    const w = Xn[g];
    if (!w)
      return;
    Nn(W.remember);
    const L = _n();
    sn(L);
    const q = ln(Zt, L), ce = W.remember ? "1" : "0";
    at(
      `${bt}${w}?returnTo=${encodeURIComponent(q)}&remember=${ce}`
    );
  }, fr = async (g) => {
    if (yt.current !== null)
      return;
    je(null);
    const w = Qa(W.email);
    if (!w) {
      pe((L) => ({
        ...L,
        email: m("en-US", "loginInvalidEmail")
      })), je(st(400));
      return;
    }
    pe((L) => {
      const { email: q, ...ce } = L;
      return ce;
    });
    try {
      yt.current = g, Wt(g);
      const L = await fetch(`${bt}/api/auth/saml/discover`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json"
        },
        credentials: "include",
        body: JSON.stringify({ domain: w })
      });
      if (!L.ok) {
        je(st(L.status));
        return;
      }
      const q = await L.json(), ce = typeof q.tenantSlug == "string" ? q.tenantSlug.trim() : "";
      if (!ce) {
        je(st(void 0));
        return;
      }
      Nn(W.remember);
      const Ae = _n();
      sn(Ae);
      const _e = ln(Zt, Ae);
      at(
        `${bt}/api/auth/saml/login/${encodeURIComponent(ce)}?returnTo=${encodeURIComponent(_e)}`
      );
    } catch {
      je(st(void 0));
    } finally {
      yt.current = null, Wt(null);
    }
  }, rn = async () => {
    if (se(null), !pt) {
      se("Enter the verification or backup code.");
      return;
    }
    if (!Re) {
      se("Sign in first to request a verification code.");
      return;
    }
    if (!Ut) {
      se("We could not identify your account. Please sign in again.");
      return;
    }
    try {
      Rt(!0);
      const g = await he({
        userId: Ut,
        challengeId: Re,
        code: pt,
        remember: W.remember,
        ...nt && Ft ? { rememberDevice: !0, deviceInfo: Ma() } : {}
      });
      ne("success", m("en-US", "loginSuccess")), we(!1), Ce(""), xe(""), qe(g), Ge(g);
    } catch (g) {
      if (un(g)) {
        const { code: w, message: L } = cn(
          g,
          "Verification failed"
        );
        se(w === "otp-invalid" ? "Invalid code. Please try again." : w === "otp-expired" ? "Code expired. Request a new code." : w === "otp-rate-limited" ? "Too many attempts. Please wait and try again." : w === "server-error" || w === "network-error" ? `${L}. You can try again.` : L);
      } else
        se("Verification failed");
    } finally {
      Rt(!1);
    }
  };
  ie(() => {
    Ve || (Ce(""), xe(""), Ue(""), rt(!1), se(null));
  }, [Ve]), ie(() => {
    const { pathname: g, search: w } = window.location, L = _o(window.location);
    if (!L) return;
    const { code: q, provider: ce = "", description: Ae } = L, _e = ce.toLowerCase(), Ye = (Ae || "").trim(), Ke = _e ? _e.charAt(0).toUpperCase() + _e.slice(1) : "Social account";
    q === "not-linked" ? ne(
      "error",
      `${Ke} is not linked to your account yet. Sign in with your email to finish linking.`
    ) : q === "oauth-failed" ? ne("error", `${Ke} authentication failed.`, Ye || void 0) : ne("error", "Authentication failed.", Ye || void 0), Ln(), An($a(g, w));
  }, [ne]);
  const pr = B?.length ? B : ["Secure single sign-on", "Multi-factor authentication", "Enterprise-grade security"], ot = n === "embedded", on = /* @__PURE__ */ d(He, { className: T.loginCard, variant: "borderless", children: [
    /* @__PURE__ */ e(Ia, { level: 3, className: T.title, children: "Welcome back" }),
    /* @__PURE__ */ d(Ne, { className: T.subtitle, children: [
      "Sign in to continue to ",
      Me
    ] }),
    Q && /* @__PURE__ */ e(
      $e,
      {
        title: m("en-US", "loginFailedTitle"),
        description: /401|invalid/i.test(Q.message) ? "Email or password incorrect." : /423|lock/i.test(Q.message) ? "Your account is locked due to multiple failed attempts." : Q?.message,
        type: "error",
        showIcon: !0,
        className: T.errorAlert
      }
    ),
    Vt && /* @__PURE__ */ e($e, { title: Vt, type: "error", showIcon: !0, className: T.errorAlert }),
    nn && /* @__PURE__ */ e("div", { style: { marginTop: "16px" }, className: T.ssoButtonsContainer, children: tn.map((g) => {
      const w = g.kind === "enterprise-saml" && rr === g.id;
      return /* @__PURE__ */ d(
        "button",
        {
          type: "button",
          className: T[Wa[g.id]],
          disabled: w,
          onClick: () => {
            if (g.kind === "oauth") {
              gr(g.id);
              return;
            }
            fr(g.id);
          },
          children: [
            g.icon,
            /* @__PURE__ */ e("span", { children: w ? "Finding Microsoft SSO..." : g.label })
          ]
        },
        `${g.kind}:${g.id}`
      );
    }) }),
    M && /* @__PURE__ */ d("div", { className: T.passkeyContainer, children: [
      /* @__PURE__ */ e(
        U,
        {
          type: "default",
          size: "large",
          block: !0,
          onClick: hr,
          loading: $t,
          disabled: !mr || $t,
          className: T.passkeyButton,
          children: ur
        }
      ),
      en && /* @__PURE__ */ e(Ne, { type: "secondary", className: T.passkeyHelper, children: en }),
      zt && /* @__PURE__ */ e($e, { type: "error", title: zt, showIcon: !0 })
    ] }),
    nn && /* @__PURE__ */ d("div", { className: T.dividerWrapper, children: [
      /* @__PURE__ */ e("div", { className: T.dividerLine }),
      /* @__PURE__ */ e("span", { children: "or continue with email" }),
      /* @__PURE__ */ e("div", { className: T.dividerLine })
    ] }),
    /* @__PURE__ */ d("form", { onSubmit: ar, children: [
      /* @__PURE__ */ d("div", { className: T.formGroup, children: [
        /* @__PURE__ */ e("label", { className: T.formLabel, htmlFor: "email", children: "Email address" }),
        /* @__PURE__ */ e(
          V,
          {
            type: "email",
            size: "large",
            id: "email",
            className: T.formInput,
            value: W.email,
            onChange: Gt("email"),
            autoComplete: "username",
            status: ge.email ? "error" : "",
            placeholder: h || "you@example.com"
          }
        ),
        ge.email && /* @__PURE__ */ e(Ne, { type: "danger", style: { fontSize: 12, marginTop: 4 }, children: ge.email })
      ] }),
      /* @__PURE__ */ d("div", { className: T.formGroup, children: [
        /* @__PURE__ */ e("label", { className: T.formLabel, htmlFor: "password", children: "Password" }),
        /* @__PURE__ */ e(
          V.Password,
          {
            size: "large",
            id: "password",
            className: T.formInput,
            value: W.password,
            onChange: Gt("password"),
            autoComplete: "current-password",
            status: ge.password ? "error" : "",
            placeholder: f || "Enter your password"
          }
        ),
        ge.password && /* @__PURE__ */ e(Ne, { type: "danger", style: { fontSize: 12, marginTop: 4 }, children: ge.password })
      ] }),
      /* @__PURE__ */ d("div", { className: T.optionsRow, children: [
        /* @__PURE__ */ e(
          Oe,
          {
            checked: W.remember,
            onChange: or,
            className: T.rememberMe,
            children: "Remember me"
          }
        ),
        k ? /* @__PURE__ */ e(dt, { to: k, className: T.forgotLink, children: "Forgot password?" }) : Jt ? /* @__PURE__ */ e("a", { href: Jt, className: T.forgotLink, children: "Forgot password?" }) : null
      ] }),
      /* @__PURE__ */ e(
        U,
        {
          htmlType: "submit",
          type: "primary",
          size: "large",
          disabled: !cr || F,
          loading: F,
          block: !0,
          className: T.submitButton,
          children: "Sign in"
        }
      )
    ] }),
    /* @__PURE__ */ e("div", { className: T.mfaToggle, children: /* @__PURE__ */ e(
      Ir,
      {
        activeKey: Ve ? ["mfa"] : [],
        onChange: (g) => {
          const w = Array.isArray(g) ? g.includes("mfa") : !!g;
          we(w);
        },
        ghost: !0,
        items: [
          {
            key: "mfa",
            label: /* @__PURE__ */ e(Ne, { type: "secondary", children: "Have a verification code?" }),
            children: /* @__PURE__ */ e("div", { className: T.mfaCard, children: /* @__PURE__ */ d(Y, { orientation: "vertical", className: T.fullWidth, size: "middle", children: [
              /* @__PURE__ */ e(Ne, { type: "secondary", children: Re ? "Enter the verification or backup code to finish signing in, then press Enter or Verify." : "Sign in first to request a verification code." }),
              /* @__PURE__ */ e(
                V,
                {
                  placeholder: "Enter code",
                  inputMode: "text",
                  value: pt,
                  onChange: (g) => Ue(Pa(g.target.value)),
                  onPressEnter: rn,
                  maxLength: Zn,
                  size: "large",
                  className: T.formInput,
                  disabled: !Re
                }
              ),
              nt && /* @__PURE__ */ d(
                Oe,
                {
                  checked: Ft,
                  disabled: !Re,
                  onChange: (g) => rt(g.target.checked),
                  className: T.rememberDevice,
                  children: [
                    "Remember this device for ",
                    tt,
                    " days"
                  ]
                }
              ),
              Bt && /* @__PURE__ */ e($e, { type: "error", title: Bt, showIcon: !0 }),
              /* @__PURE__ */ e(
                U,
                {
                  type: "primary",
                  onClick: rn,
                  loading: nr || ae,
                  disabled: !Re,
                  block: !0,
                  size: "large",
                  className: T.submitButton,
                  children: "Verify"
                }
              )
            ] }) })
          }
        ]
      }
    ) }),
    /* @__PURE__ */ e("div", { className: T.signupText, children: /* @__PURE__ */ d(Ne, { children: [
      m("en-US", "dontHaveAccount"),
      /* @__PURE__ */ e(dt, { to: dr, className: T.signupLink, children: m("en-US", "signUpButton") })
    ] }) })
  ] });
  return o ? /* @__PURE__ */ e(
    et,
    {
      open: !0,
      centered: !0,
      footer: null,
      onCancel: s,
      width: 480,
      destroyOnHidden: !0,
      closable: !0,
      maskClosable: !0,
      keyboard: !0,
      className: ft ? T.darkModal : void 0,
      styles: { body: { padding: 0 }, mask: { borderRadius: 24 } },
      children: /* @__PURE__ */ e("div", { style: qt, children: on })
    }
  ) : /* @__PURE__ */ d(
    de,
    {
      className: `${T.loginContainer}${ot ? ` ${T.embeddedContainer}` : ""}`,
      style: qt,
      children: [
        !ot && /* @__PURE__ */ d("div", { className: T.heroSection, children: [
          /* @__PURE__ */ d("div", { className: T.floatingShapes, children: [
            /* @__PURE__ */ e("div", { className: `${T.shape} ${T.shape1}` }),
            /* @__PURE__ */ e("div", { className: `${T.shape} ${T.shape2}` }),
            /* @__PURE__ */ e("div", { className: `${T.shape} ${T.shape3}` })
          ] }),
          /* @__PURE__ */ d("div", { className: T.heroContent, children: [
            /* @__PURE__ */ e("h1", { className: T.heroTitle, children: b || Me }),
            /* @__PURE__ */ e("p", { className: T.heroSubtitle, children: O || "Your complete business management platform" }),
            /* @__PURE__ */ e("div", { className: T.heroFeatures, children: pr.map((g, w) => /* @__PURE__ */ d("div", { className: T.heroFeature, children: [
              /* @__PURE__ */ e("span", { className: T.heroFeatureIcon, children: /* @__PURE__ */ e(Wr, { style: { color: "#fff", fontSize: 14 } }) }),
              /* @__PURE__ */ e("span", { children: g })
            ] }, w)) })
          ] })
        ] }),
        !ot && /* @__PURE__ */ d(be, { children: [
          /* @__PURE__ */ e(
            "div",
            {
              className: `${T.background} ${i ?? ""}`,
              style: a ? {
                backgroundImage: `url(${a})`,
                backgroundSize: "cover",
                backgroundPosition: "center"
              } : void 0
            }
          ),
          l !== "none" && /* @__PURE__ */ e("div", { className: T.gradientOverlay })
        ] }),
        /* @__PURE__ */ e(
          La,
          {
            className: `${T.loginContent}${ot ? ` ${T.embeddedContent}` : ""}`,
            children: on
          }
        )
      ]
    }
  );
}, Xa = "_page_18e0n_1", Za = "_shell_18e0n_9", Ja = "_brandPanel_18e0n_20", es = "_brandContent_18e0n_29", ts = "_brandBadge_18e0n_34", ns = "_brandTitle_18e0n_46", rs = "_brandSubtitle_18e0n_51", os = "_brandList_18e0n_55", is = "_brandQuote_18e0n_63", as = "_brandQuoteText_18e0n_71", ss = "_brandQuoteAuthor_18e0n_76", ls = "_formPanel_18e0n_82", cs = "_formHeader_18e0n_89", ds = "_alert_18e0n_94", us = "_footerRow_18e0n_98", ms = "_link_18e0n_102", oe = {
  page: Xa,
  shell: Za,
  brandPanel: Ja,
  brandContent: es,
  brandBadge: ts,
  brandTitle: ns,
  brandSubtitle: rs,
  brandList: os,
  brandQuote: is,
  brandQuoteText: as,
  brandQuoteAuthor: ss,
  formPanel: ls,
  formHeader: cs,
  alert: ds,
  footerRow: us,
  link: ms
}, { Title: In, Text: Qe } = $, hs = [
  "Secure access with role-based permissions.",
  "Unified records across teams and workflows.",
  "Live reporting for confident decisions."
], Ml = ({
  appName: t,
  logoLightSrc: n,
  logoDarkSrc: r,
  highlights: o = hs,
  quote: i = '"Onboarding our team took minutes, not days."',
  quoteAuthor: a = "Operations Lead"
}) => {
  const { message: l } = Te.useApp(), { locale: s } = Gr(), c = ht(), { register: u, loading: h, error: f } = On(), { token: A } = J.useToken(), x = z.useMemo(() => {
    const v = typeof t == "string" ? t.trim() : "";
    if (v && v.toLowerCase() !== "undefined" && v.toLowerCase() !== "null")
      return v;
    const E = typeof document < "u" ? document.title : "", b = typeof E == "string" ? E.trim() : "";
    return b && b.toLowerCase() !== "undefined" && b.toLowerCase() !== "null" ? b : "DigiWedge";
  }, [t]), y = async (v) => {
    try {
      await u(v), l.success(m(s, "registrationSuccess")), c("/login");
    } catch {
      l.error(m(s, "registrationError"));
    }
  }, k = {
    "--register-bg": A.colorBgLayout || "#f0f2f5",
    "--register-surface": A.colorBgContainer || "#ffffff",
    "--register-border": A.colorBorderSecondary || "#e6e8ec",
    "--register-primary": A.colorPrimary || "#1677ff"
  };
  return /* @__PURE__ */ e("div", { className: oe.page, style: k, children: /* @__PURE__ */ d("div", { className: oe.shell, children: [
    /* @__PURE__ */ d("aside", { className: oe.brandPanel, children: [
      /* @__PURE__ */ e(
        Wn,
        {
          themeMode: "dark",
          size: "medium",
          lightLogoSrc: n,
          darkLogoSrc: r,
          alt: `${x} logo`
        }
      ),
      /* @__PURE__ */ d("div", { className: oe.brandContent, children: [
        /* @__PURE__ */ e("span", { className: oe.brandBadge, children: m(s, "signUpButton") }),
        /* @__PURE__ */ d(In, { level: 2, className: oe.brandTitle, children: [
          "Create your ",
          x,
          " account"
        ] }),
        /* @__PURE__ */ e(Qe, { className: oe.brandSubtitle, children: "Bring your team together with secure access and unified workflows." })
      ] }),
      /* @__PURE__ */ e("ul", { className: oe.brandList, children: o.map((v) => /* @__PURE__ */ e("li", { children: v }, v)) }),
      /* @__PURE__ */ d("div", { className: oe.brandQuote, children: [
        /* @__PURE__ */ e(Qe, { className: oe.brandQuoteText, children: i }),
        /* @__PURE__ */ e(Qe, { className: oe.brandQuoteAuthor, children: a })
      ] })
    ] }),
    /* @__PURE__ */ d("section", { className: oe.formPanel, children: [
      /* @__PURE__ */ d("div", { className: oe.formHeader, children: [
        /* @__PURE__ */ e(In, { level: 3, children: m(s, "registerHeading").replace("{appName}", x) }),
        /* @__PURE__ */ e(Qe, { type: "secondary", children: "Fill in the details below to get started." })
      ] }),
      f && /* @__PURE__ */ e(
        $e,
        {
          message: m(s, "registrationFailedTitle"),
          description: f.message,
          type: "error",
          showIcon: !0,
          className: oe.alert
        }
      ),
      /* @__PURE__ */ d(_, { name: "register", layout: "vertical", onFinish: y, children: [
        /* @__PURE__ */ e(
          _.Item,
          {
            label: m(s, "emailLabel"),
            name: "email",
            rules: [
              {
                required: !0,
                message: m(s, "registerAccountEmailRequired")
              },
              {
                type: "email",
                message: m(s, "registerAccountInvalidEmail")
              }
            ],
            children: /* @__PURE__ */ e(V, { placeholder: m(s, "emailPlaceholder"), size: "large" })
          }
        ),
        /* @__PURE__ */ e(
          _.Item,
          {
            label: m(s, "passwordLabel"),
            name: "password",
            rules: [
              {
                required: !0,
                message: m(s, "registerAccountPasswordRequired")
              },
              {
                min: 8,
                message: m(s, "registerAccountPasswordMin")
              }
            ],
            children: /* @__PURE__ */ e(
              V.Password,
              {
                placeholder: m(s, "passwordPlaceholder"),
                size: "large"
              }
            )
          }
        ),
        /* @__PURE__ */ e(
          _.Item,
          {
            label: m(s, "firstNameLabel"),
            name: "givenName",
            rules: [
              {
                required: !0,
                message: m(s, "registerAccountFirstNameRequired")
              }
            ],
            children: /* @__PURE__ */ e(V, { size: "large" })
          }
        ),
        /* @__PURE__ */ e(
          _.Item,
          {
            label: m(s, "lastNameLabel"),
            name: "familyName",
            rules: [
              {
                required: !0,
                message: m(s, "registerAccountLastNameRequired")
              }
            ],
            children: /* @__PURE__ */ e(V, { size: "large" })
          }
        ),
        /* @__PURE__ */ e(_.Item, { label: m(s, "preferredNameLabel"), name: "preferredName", children: /* @__PURE__ */ e(V, { size: "large" }) }),
        /* @__PURE__ */ e(
          _.Item,
          {
            name: "termsAccepted",
            valuePropName: "checked",
            rules: [
              {
                validator: (v, E) => E ? Promise.resolve() : Promise.reject(new Error(m(s, "termsRequired")))
              }
            ],
            children: /* @__PURE__ */ e(Oe, { children: m(s, "termsAcceptLabel") })
          }
        ),
        /* @__PURE__ */ e(U, { type: "primary", htmlType: "submit", block: !0, size: "large", loading: h, children: m(s, "signUpButton") })
      ] }),
      /* @__PURE__ */ e("div", { className: oe.footerRow, children: /* @__PURE__ */ d(Qe, { children: [
        m(s, "alreadyHaveAccount"),
        " ",
        /* @__PURE__ */ e(dt, { to: "/login", className: oe.link, children: m(s, "loginLinkText") })
      ] }) })
    ] })
  ] }) });
}, Ul = () => {
  const t = ht(), { logout: n } = wo(), { token: r } = J.useToken(), { message: o } = Te.useApp(), i = Ie(!1);
  return ie(() => {
    if (i.current)
      return;
    i.current = !0, (async () => {
      try {
        await n(), o.success(m("en-US", "logoutSuccess"));
      } catch {
        o.error(m("en-US", "logoutError"));
      } finally {
        t("/login", { replace: !0 });
      }
    })();
  }, [n, t, o]), /* @__PURE__ */ e(
    "div",
    {
      style: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        backgroundColor: r.colorBgContainer
      },
      children: /* @__PURE__ */ d("div", { style: { display: "grid", justifyItems: "center", gap: 12 }, children: [
        /* @__PURE__ */ e(En, { size: "large" }),
        /* @__PURE__ */ e("span", { style: { color: r.colorTextSecondary }, children: m("en-US", "logoutProgress") })
      ] })
    }
  );
}, gs = () => /* @__PURE__ */ d("div", { children: [
  /* @__PURE__ */ e("h2", { children: m("en-US", "registrationComplete") }),
  /* @__PURE__ */ e("p", { children: m("en-US", "registrationCompleteDetail") }),
  /* @__PURE__ */ e("p", { children: /* @__PURE__ */ e("a", { href: "/login", children: m("en-US", "goToLogin") }) })
] }), fs = ({
  onNext: t,
  loading: n,
  serverError: r
}) => {
  const { message: o } = Te.useApp(), [i] = _.useForm();
  return ie(() => {
    if (r?.fieldErrors) {
      const l = Object.entries(r.fieldErrors).map(
        ([s, c]) => ({
          name: [s],
          errors: [c]
        })
      );
      i.setFields(l);
    }
  }, [r, i]), /* @__PURE__ */ e("div", { children: /* @__PURE__ */ d(
    _,
    {
      form: i,
      layout: "vertical",
      onFinish: async (l) => {
        try {
          await t(l);
        } catch {
          o.error(m("en-US", "registrationSubmitError"));
        }
      },
      onFinishFailed: (l) => {
        process.env.NODE_ENV !== "test" && console.warn("Validation Failed:", l);
      },
      children: [
        /* @__PURE__ */ e(
          _.Item,
          {
            label: m("en-US", "emailLabel"),
            name: "email",
            rules: [
              {
                required: !0,
                message: m("en-US", "registerAccountEmailRequired")
              },
              {
                type: "email",
                message: m("en-US", "registerAccountInvalidEmail")
              }
            ],
            children: /* @__PURE__ */ e(V, {})
          }
        ),
        /* @__PURE__ */ e(
          _.Item,
          {
            label: m("en-US", "passwordLabel"),
            name: "password",
            rules: [
              {
                required: !0,
                message: m("en-US", "registerAccountPasswordRequired")
              },
              {
                min: 8,
                message: m("en-US", "registerAccountPasswordMin")
              },
              {
                validator: (l, s) => {
                  if (!s) return Promise.resolve();
                  const c = /[A-Z]/.test(s), u = /[a-z]/.test(s), h = /\d/.test(s);
                  return !c || !u || !h ? Promise.reject(m("en-US", "registerAccountPasswordComplex")) : Promise.resolve();
                }
              }
            ],
            children: /* @__PURE__ */ e(V.Password, {})
          }
        ),
        /* @__PURE__ */ e(
          _.Item,
          {
            label: m("en-US", "firstNameLabel"),
            name: "givenName",
            rules: [
              {
                required: !0,
                message: m("en-US", "registerAccountFirstNameRequired")
              }
            ],
            children: /* @__PURE__ */ e(V, {})
          }
        ),
        /* @__PURE__ */ e(
          _.Item,
          {
            label: m("en-US", "lastNameLabel"),
            name: "familyName",
            rules: [
              {
                required: !0,
                message: m("en-US", "registerAccountLastNameRequired")
              }
            ],
            children: /* @__PURE__ */ e(V, {})
          }
        ),
        /* @__PURE__ */ e(_.Item, { label: m("en-US", "preferredNameLabel"), name: "preferredName", children: /* @__PURE__ */ e(V, {}) }),
        /* @__PURE__ */ e(U, { type: "primary", htmlType: "submit", block: !0, loading: n, children: m("en-US", "registerButton") })
      ]
    }
  ) });
}, ps = ({ onLogin: t, loading: n }) => {
  const [r] = _.useForm();
  async function o(i) {
    await t(i);
  }
  return /* @__PURE__ */ d("div", { children: [
    /* @__PURE__ */ e("h2", { children: m("en-US", "loginHeading") }),
    /* @__PURE__ */ d(
      _,
      {
        form: r,
        layout: "vertical",
        onFinish: o,
        initialValues: { email: "", password: "" },
        children: [
          /* @__PURE__ */ e(
            _.Item,
            {
              label: m("en-US", "emailLabel"),
              name: "email",
              rules: [
                {
                  required: !0,
                  message: m("en-US", "loginEmailRequired")
                },
                {
                  type: "email",
                  message: m("en-US", "loginInvalidEmail")
                }
              ],
              children: /* @__PURE__ */ e(V, {})
            }
          ),
          /* @__PURE__ */ e(
            _.Item,
            {
              label: m("en-US", "passwordLabel"),
              name: "password",
              rules: [
                {
                  required: !0,
                  message: m("en-US", "loginPasswordRequired")
                }
              ],
              children: /* @__PURE__ */ e(V.Password, {})
            }
          ),
          /* @__PURE__ */ e(U, { type: "primary", htmlType: "submit", block: !0, loading: n, children: m("en-US", "loginButton") })
        ]
      }
    )
  ] });
}, ys = ({ onNext: t, loading: n }) => {
  const [r] = _.useForm(), o = (i) => {
    t(i);
  };
  return /* @__PURE__ */ d("div", { children: [
    /* @__PURE__ */ e("h2", { children: m("en-US", "mfaPhoneHeading") }),
    /* @__PURE__ */ d(_, { form: r, layout: "vertical", onFinish: o, children: [
      /* @__PURE__ */ e(
        _.Item,
        {
          label: m("en-US", "phoneNumberLabel"),
          name: "phoneNumber",
          rules: [
            {
              required: !0,
              message: m("en-US", "mfaPhoneRequired")
            }
          ],
          children: /* @__PURE__ */ e(V, { placeholder: m("en-US", "phoneNumberPlaceholder") })
        }
      ),
      /* @__PURE__ */ e(_.Item, { label: m("en-US", "mfaSecretLabel"), name: "secret", rules: [], children: /* @__PURE__ */ e(V, { placeholder: m("en-US", "mfaSecretPlaceholder") }) }),
      /* @__PURE__ */ e(U, { type: "primary", htmlType: "submit", block: !0, loading: n, children: m("en-US", "sendCodeButton") })
    ] })
  ] });
}, bs = ({ onVerify: t, loading: n }) => {
  const [r] = _.useForm(), o = (i) => {
    t(i.code);
  };
  return /* @__PURE__ */ d("div", { children: [
    /* @__PURE__ */ e("h2", { children: m("en-US", "mfaCodeHeading") }),
    /* @__PURE__ */ d(_, { form: r, layout: "vertical", onFinish: o, children: [
      /* @__PURE__ */ e(
        _.Item,
        {
          label: m("en-US", "mfaCodeLabel"),
          name: "code",
          rules: [{ required: !0, message: m("en-US", "mfaCodeRequired") }],
          children: /* @__PURE__ */ e(V, { placeholder: m("en-US", "mfaPlaceholderCode") })
        }
      ),
      /* @__PURE__ */ e(U, { type: "primary", htmlType: "submit", block: !0, loading: n, children: m("en-US", "verifyButton") })
    ] })
  ] });
};
function Dn(t) {
  return typeof t == "object" && t !== null && t.isAxiosError === !0;
}
function Ss(t) {
  switch (t) {
    case "ACCOUNT":
      return 0;
    case "LOGIN":
      return 1;
    case "MFA_PHONE":
      return 2;
    case "MFA_CODE":
      return 3;
    case "DONE":
      return 4;
  }
}
const Rl = () => {
  const { token: t } = J.useToken(), { message: n } = Te.useApp(), [r, o] = I("ACCOUNT"), [i, a] = I(""), [l, s] = I(null), { register: c, loading: u } = On(), { login: h, loading: f } = $n(), { registerSmsMfa: A, loading: x } = ko(), { verifySmsMfa: y, loading: k } = Co();
  async function v(H) {
    s(null);
    try {
      const C = await c(H);
      a(C.userId), n.success(m("en-US", "accountCreatedSuccess")), o("LOGIN");
    } catch (C) {
      throw Dn(C) && C.response?.status === 409 ? s({
        message: m("en-US", "emailAlreadyExists"),
        fieldErrors: { email: m("en-US", "emailAlreadyExists") }
      }) : s({
        message: m("en-US", "registrationError")
      }), C;
    }
  }
  async function E(H) {
    try {
      await h(H), n.success(m("en-US", "loginSuccess")), o("MFA_PHONE");
    } catch {
      n.error(m("en-US", "loginCheckError"));
    }
  }
  async function b(H) {
    try {
      await A(H), n.success(m("en-US", "mfaInitiatedSuccess")), o("MFA_CODE");
    } catch (C) {
      Dn(C) && C.response?.status === 400 ? s({
        message: m("en-US", "invalidPhoneNumber"),
        fieldErrors: {
          phoneNumber: m("en-US", "invalidPhoneNumberField")
        }
      }) : s({
        message: m("en-US", "registerPhoneNumberError")
      }), n.error(m("en-US", "mfaPhoneError"));
    }
  }
  async function O(H) {
    try {
      await y({ userId: i, code: H }), n.success(m("en-US", "mfaVerifiedSuccess")), o("DONE");
    } catch {
      n.error(m("en-US", "mfaCodeError"));
    }
  }
  let B;
  return r === "ACCOUNT" ? B = /* @__PURE__ */ e(
    fs,
    {
      onNext: v,
      loading: u,
      serverError: l
    }
  ) : r === "LOGIN" ? B = /* @__PURE__ */ e(ps, { onLogin: E, loading: f }) : r === "MFA_PHONE" ? B = /* @__PURE__ */ e(ys, { onNext: b, loading: x }) : r === "MFA_CODE" ? B = /* @__PURE__ */ e(bs, { onVerify: O, loading: k }) : B = /* @__PURE__ */ e(gs, {}), /* @__PURE__ */ e(
    "div",
    {
      style: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        backgroundColor: t.colorBgBase,
        padding: t.paddingLG
      },
      children: /* @__PURE__ */ d(
        He,
        {
          style: {
            maxWidth: 600,
            width: "100%",
            padding: t.paddingMD,
            backgroundColor: t.colorBgContainer,
            boxShadow: t.boxShadow
          },
          children: [
            /* @__PURE__ */ e(
              It,
              {
                current: Ss(r),
                style: { marginBottom: t.marginLG },
                items: [
                  { title: m("en-US", "registrationStepAccount") },
                  { title: m("en-US", "registrationStepLogin") },
                  { title: m("en-US", "registrationStepPhone") },
                  { title: m("en-US", "registrationStepCode") },
                  { title: m("en-US", "registrationStepDone") }
                ]
              }
            ),
            B
          ]
        }
      )
    }
  );
}, { Content: vs } = de, { Title: ws, Text: ks } = $, Bl = ({ user: t }) => {
  const n = typeof t.avatar == "string" ? t.avatar : void 0;
  return /* @__PURE__ */ e(de, { style: { backgroundColor: "#f9f9f9" }, children: /* @__PURE__ */ d(vs, { style: { padding: "40px 24px" }, children: [
    /* @__PURE__ */ e(vt, { justify: "center", style: { textAlign: "center", marginBottom: 40 }, children: /* @__PURE__ */ d(ct, { children: [
      /* @__PURE__ */ e(
        Rn,
        {
          size: 96,
          src: n,
          style: { backgroundColor: "#1890ff", marginBottom: 16 },
          children: t.displayName.charAt(0)
        }
      ),
      /* @__PURE__ */ e(ws, { level: 3, children: t.displayName }),
      /* @__PURE__ */ e(ks, { type: "secondary", children: t.email })
    ] }) }),
    /* @__PURE__ */ e(vt, { justify: "center", children: /* @__PURE__ */ e(ct, { xs: 24, sm: 20, md: 16, lg: 12, children: /* @__PURE__ */ d(
      ue,
      {
        bordered: !0,
        column: 1,
        layout: "vertical",
        style: { backgroundColor: "#fff", padding: 24, borderRadius: 12 },
        children: [
          /* @__PURE__ */ e(ue.Item, { label: "Full Name", children: t.fullName || "N/A" }),
          /* @__PURE__ */ e(ue.Item, { label: "Preferred Name", children: t.preferredName || "N/A" }),
          /* @__PURE__ */ e(ue.Item, { label: "Given Name", children: t.givenName || "N/A" }),
          /* @__PURE__ */ e(ue.Item, { label: "Family Name", children: t.familyName || "N/A" }),
          /* @__PURE__ */ e(ue.Item, { label: "Status", children: t.active ? /* @__PURE__ */ e(Se, { color: "green", children: "Active" }) : /* @__PURE__ */ e(Se, { color: "red", children: "Inactive" }) }),
          /* @__PURE__ */ e(ue.Item, { label: "Feature Flags", children: t.featureFlags?.length ? t.featureFlags.map((r) => /* @__PURE__ */ e(Se, { color: "blue", children: r }, r)) : "None" })
        ]
      }
    ) }) })
  ] }) });
}, Fl = () => {
  const { toggleTheme: t } = Et();
  return t;
}, $l = () => !Lt.useBreakpoint().md, Ol = () => new Promise((t, n) => {
  if (!navigator.geolocation) {
    n(new Error("Geolocation is not supported by this browser."));
    return;
  }
  navigator.geolocation.getCurrentPosition(
    (r) => {
      const { latitude: o, longitude: i } = r.coords;
      t({ latitude: o, longitude: i });
    },
    (r) => {
      n(new Error(`Failed to get location: ${r.message}`));
    },
    {
      enableHighAccuracy: !0,
      timeout: 1e4,
      maximumAge: 0
    }
  );
});
function zl() {
  const { message: t } = Te.useApp();
  return {
    success(n) {
      t.success(n);
    },
    error(n) {
      t.error(n);
    }
  };
}
export {
  rl as ActionFooter,
  nl as AdminFooter,
  al as AnalyticsFooter,
  Vl as AppThemeProvider,
  bl as BalanceWidget,
  Xs as BreadcrumbComponent,
  Il as Button,
  Zs as CardUI,
  pl as ClassificationTree,
  Js as ContentWrapper,
  Al as CsvDropzone,
  yl as CurrencyInput,
  ii as CustomBarShape,
  Ko as DEFAULT_SIDEBAR_HEADER_OFFSET,
  jn as DateRangePicker,
  gs as DoneScreen,
  qn as Drawer,
  El as ENTERPRISE_ADMIN_LOGIN_PROVIDERS,
  Ee as FOOTER_MIN_HEIGHT,
  wl as FeatureUsageDashboard,
  tl as FooterComponent,
  ll as HeaderComponent,
  vl as InvoicePreviewModal,
  Sl as InvoiceTable,
  sl as LegalBar,
  Pl as Login,
  Wn as LogoComponent,
  Ul as Logout,
  Lo as MarketingFooter,
  Nl as MemberSignupWidget,
  fe as MoneyField,
  hl as PriceScheduleCreateWizard,
  gl as PriceScheduleEditModal,
  ml as PriceScheduleTimeline,
  Tl as ProductVariantModal,
  di as RANGE_ERROR_END_AFTER_START,
  ui as RANGE_ERROR_OVERLAP,
  Ml as Register,
  Rl as RegistrationWizard,
  zn as SAFE_AREA_INSET_BOTTOM,
  cl as SidebarComponent,
  Ai as SignupForm,
  ut as StatusChip,
  fs as StepAccountForm,
  bs as StepMfaCodeForm,
  ys as StepMfaPhoneForm,
  kl as SystemHealthWidget,
  ol as TableFooterBar,
  ul as TagChip,
  il as TenantFooter,
  Cl as TenantOnboardingWizard,
  Ll as TextInput,
  Dl as ThemeToggle,
  Bl as UserProfilePage,
  _l as WebBrandingProvider,
  lt as cloneDataNodes,
  Qo as createSidebarViewportStyle,
  jl as dark,
  Kn as filterTree,
  kt as findNode,
  De as findParent,
  fl as flatten,
  Pt as formatCurrency,
  Le as fromDataNode,
  Ol as getBrowserLocation,
  el as getSafeAreaPaddingBottom,
  wn as indentNode,
  Kl as isVerifiedSocialAuthCallbackReturn,
  ql as light,
  it as maxDepth,
  vn as moveNodeDown,
  Sn as moveNodeUp,
  kn as outdentNode,
  Ct as removeNode,
  Ra as resolveSocialAuthReturnTo,
  Ua as resolveSocialReturnTo,
  wt as toDataNode,
  Gn as updateTitle,
  xi as useCreateTenantMutation,
  $l as useIsMobile,
  zl as useNotifications,
  dl as usePersistentSidebarOpenKeys,
  Gl as useTheme,
  Fl as useThemeToggle,
  xl as useWebBranding,
  Nt as withExternalAuthSync
};
//# sourceMappingURL=index.js.map
